/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SubscriptionEndedRouteImport } from './routes/subscription-ended'
import { Route as PosRouteImport } from './routes/pos'
import { Route as LaunchRouteImport } from './routes/launch'
import { Route as workspaceRouteRouteImport } from './routes/(workspace)/route'
import { Route as StationIndexRouteImport } from './routes/station/index'
import { Route as workspaceIndexRouteImport } from './routes/(workspace)/index'
import { Route as workspaceApprovalsRouteImport } from './routes/(workspace)/approvals'
import { Route as workspaceReportsRouteRouteImport } from './routes/(workspace)/reports/route'
import { Route as workspacePayrollRouteRouteImport } from './routes/(workspace)/payroll/route'
import { Route as workspaceDocumentsRouteRouteImport } from './routes/(workspace)/documents/route'
import { Route as workspaceSettingsIndexRouteImport } from './routes/(workspace)/settings/index'
import { Route as workspaceReportsIndexRouteImport } from './routes/(workspace)/reports/index'
import { Route as workspaceProfileIndexRouteImport } from './routes/(workspace)/profile/index'
import { Route as workspacePayrollIndexRouteImport } from './routes/(workspace)/payroll/index'
import { Route as workspaceDocumentsIndexRouteImport } from './routes/(workspace)/documents/index'
import { Route as workspaceAskIndexRouteImport } from './routes/(workspace)/ask/index'
import { Route as workspaceApprovalsIndexRouteImport } from './routes/(workspace)/approvals/index'
import { Route as authSignInIndexRouteImport } from './routes/(auth)/sign-in/index'
import { Route as workspaceReportsNewRouteImport } from './routes/(workspace)/reports/new'
import { Route as workspaceReportsReportKeyRouteImport } from './routes/(workspace)/reports/$reportKey'
import { Route as workspaceAskChatIdRouteImport } from './routes/(workspace)/ask/$chatId'
import { Route as workspaceApprovalsApprovalIdRouteImport } from './routes/(workspace)/approvals/$approvalId'
import { Route as authSignInOtpRouteImport } from './routes/(auth)/sign-in/otp'
import { Route as authOnboardingWorkspaceRouteImport } from './routes/(auth)/onboarding/workspace'
import { Route as authOnboardingTallyRouteImport } from './routes/(auth)/onboarding/tally'
import { Route as authOnboardingDoneRouteImport } from './routes/(auth)/onboarding/done'
import { Route as authOnboardingAccountRouteImport } from './routes/(auth)/onboarding/account'
import { Route as authJoinTokenRouteImport } from './routes/(auth)/join/$token'
import { Route as workspaceInventoryStockTransfersRouteRouteImport } from './routes/(workspace)/inventory/stock-transfers/route'
import { Route as workspaceComplianceBooksRouteRouteImport } from './routes/(workspace)/compliance/books/route'
import { Route as workspaceCashTransfersRouteRouteImport } from './routes/(workspace)/cash/transfers/route'
import { Route as workspaceCashReconcileRouteRouteImport } from './routes/(workspace)/cash/reconcile/route'
import { Route as workspaceCashPettyCashRouteRouteImport } from './routes/(workspace)/cash/petty-cash/route'
import { Route as workspaceCashMovementsRouteRouteImport } from './routes/(workspace)/cash/movements/route'
import { Route as workspaceStoreAdminIndexRouteImport } from './routes/(workspace)/store/admin/index'
import { Route as workspaceSettingsTemplatesIndexRouteImport } from './routes/(workspace)/settings/templates/index'
import { Route as workspaceSettingsTeamIndexRouteImport } from './routes/(workspace)/settings/team/index'
import { Route as workspaceSettingsSubscriptionIndexRouteImport } from './routes/(workspace)/settings/subscription/index'
import { Route as workspaceSettingsRolesIndexRouteImport } from './routes/(workspace)/settings/roles/index'
import { Route as workspaceSettingsRecurringIndexRouteImport } from './routes/(workspace)/settings/recurring/index'
import { Route as workspaceSettingsProfileIndexRouteImport } from './routes/(workspace)/settings/profile/index'
import { Route as workspaceSettingsNumberingIndexRouteImport } from './routes/(workspace)/settings/numbering/index'
import { Route as workspaceSettingsNotificationsIndexRouteImport } from './routes/(workspace)/settings/notifications/index'
import { Route as workspaceSettingsIntegrationsIndexRouteImport } from './routes/(workspace)/settings/integrations/index'
import { Route as workspaceSettingsGstinIndexRouteImport } from './routes/(workspace)/settings/gstin/index'
import { Route as workspaceSettingsCompanyIndexRouteImport } from './routes/(workspace)/settings/company/index'
import { Route as workspaceSettingsBillingIndexRouteImport } from './routes/(workspace)/settings/billing/index'
import { Route as workspaceSettingsAssistantIndexRouteImport } from './routes/(workspace)/settings/assistant/index'
import { Route as workspaceSettingsApprovalsIndexRouteImport } from './routes/(workspace)/settings/approvals/index'
import { Route as workspaceSettingsAboutIndexRouteImport } from './routes/(workspace)/settings/about/index'
import { Route as workspaceSalesReceiptsIndexRouteImport } from './routes/(workspace)/sales/receipts/index'
import { Route as workspaceSalesProformasIndexRouteImport } from './routes/(workspace)/sales/proformas/index'
import { Route as workspaceSalesItemsIndexRouteImport } from './routes/(workspace)/sales/items/index'
import { Route as workspaceSalesInvoicesIndexRouteImport } from './routes/(workspace)/sales/invoices/index'
import { Route as workspaceSalesCustomersIndexRouteImport } from './routes/(workspace)/sales/customers/index'
import { Route as workspaceSalesCollectionsIndexRouteImport } from './routes/(workspace)/sales/collections/index'
import { Route as workspaceRecordsAuditLogIndexRouteImport } from './routes/(workspace)/records/audit-log/index'
import { Route as workspaceProductionFloorIndexRouteImport } from './routes/(workspace)/production/floor/index'
import { Route as workspaceProcurementVendorsIndexRouteImport } from './routes/(workspace)/procurement/vendors/index'
import { Route as workspaceProcurementPurchaseOrdersIndexRouteImport } from './routes/(workspace)/procurement/purchase-orders/index'
import { Route as workspaceProcurementPaymentsIndexRouteImport } from './routes/(workspace)/procurement/payments/index'
import { Route as workspaceProcurementGoodsReceiptsIndexRouteImport } from './routes/(workspace)/procurement/goods-receipts/index'
import { Route as workspaceProcurementBillsIndexRouteImport } from './routes/(workspace)/procurement/bills/index'
import { Route as workspacePosShiftsIndexRouteImport } from './routes/(workspace)/pos/shifts/index'
import { Route as workspacePayrollEmployeesIndexRouteImport } from './routes/(workspace)/payroll/employees/index'
import { Route as workspacePayrollRunIdIndexRouteImport } from './routes/(workspace)/payroll/$runId.index'
import { Route as workspaceMerchandisingStylesIndexRouteImport } from './routes/(workspace)/merchandising/styles/index'
import { Route as workspaceMerchandisingRisksIndexRouteImport } from './routes/(workspace)/merchandising/risks/index'
import { Route as workspaceMerchandisingOrdersIndexRouteImport } from './routes/(workspace)/merchandising/orders/index'
import { Route as workspaceInventoryWarehousesIndexRouteImport } from './routes/(workspace)/inventory/warehouses/index'
import { Route as workspaceInventoryStockIndexRouteImport } from './routes/(workspace)/inventory/stock/index'
import { Route as workspaceInventoryStockTransfersIndexRouteImport } from './routes/(workspace)/inventory/stock-transfers/index'
import { Route as workspaceInventoryStockAdjustmentsIndexRouteImport } from './routes/(workspace)/inventory/stock-adjustments/index'
import { Route as workspaceComplianceTdsIndexRouteImport } from './routes/(workspace)/compliance/tds/index'
import { Route as workspaceComplianceItc04IndexRouteImport } from './routes/(workspace)/compliance/itc04/index'
import { Route as workspaceComplianceGstReturnsIndexRouteImport } from './routes/(workspace)/compliance/gst-returns/index'
import { Route as workspaceComplianceBooksIndexRouteImport } from './routes/(workspace)/compliance/books/index'
import { Route as workspaceCashTransfersIndexRouteImport } from './routes/(workspace)/cash/transfers/index'
import { Route as workspaceCashReconcileIndexRouteImport } from './routes/(workspace)/cash/reconcile/index'
import { Route as workspaceCashPettyCashIndexRouteImport } from './routes/(workspace)/cash/petty-cash/index'
import { Route as workspaceCashBankAccountsIndexRouteImport } from './routes/(workspace)/cash/bank-accounts/index'
import { Route as workspaceSalesReceiptsReceiptIdRouteImport } from './routes/(workspace)/sales/receipts/$receiptId'
import { Route as workspaceSalesProformasNewRouteImport } from './routes/(workspace)/sales/proformas/new'
import { Route as workspaceSalesItemsNewRouteImport } from './routes/(workspace)/sales/items/new'
import { Route as workspaceSalesInvoicesNewRouteImport } from './routes/(workspace)/sales/invoices/new'
import { Route as workspaceSalesCustomersNewRouteImport } from './routes/(workspace)/sales/customers/new'
import { Route as workspaceProductionFloorInwardRouteImport } from './routes/(workspace)/production/floor/inward'
import { Route as workspaceProductionFloorStageRouteImport } from './routes/(workspace)/production/floor/$stage'
import { Route as workspaceProcurementVendorsNewRouteImport } from './routes/(workspace)/procurement/vendors/new'
import { Route as workspaceProcurementPurchaseOrdersNewRouteImport } from './routes/(workspace)/procurement/purchase-orders/new'
import { Route as workspaceProcurementGoodsReceiptsNewRouteImport } from './routes/(workspace)/procurement/goods-receipts/new'
import { Route as workspaceProcurementBillsNewRouteImport } from './routes/(workspace)/procurement/bills/new'
import { Route as workspacePayrollEmployeesNewRouteImport } from './routes/(workspace)/payroll/employees/new'
import { Route as workspaceMerchandisingStylesNewRouteImport } from './routes/(workspace)/merchandising/styles/new'
import { Route as workspaceMerchandisingOrdersNewRouteImport } from './routes/(workspace)/merchandising/orders/new'
import { Route as workspaceInventoryWarehousesNewRouteImport } from './routes/(workspace)/inventory/warehouses/new'
import { Route as workspaceInventoryStockOpeningRouteImport } from './routes/(workspace)/inventory/stock/opening'
import { Route as workspaceInventoryStockTransfersNewRouteImport } from './routes/(workspace)/inventory/stock-transfers/new'
import { Route as workspaceInventoryStockAdjustmentsNewRouteImport } from './routes/(workspace)/inventory/stock-adjustments/new'
import { Route as workspaceCashTransfersNewRouteImport } from './routes/(workspace)/cash/transfers/new'
import { Route as workspaceCashTransfersMovementIdRouteImport } from './routes/(workspace)/cash/transfers/$movementId'
import { Route as workspaceCashPettyCashReplenishRouteImport } from './routes/(workspace)/cash/petty-cash/replenish'
import { Route as workspaceCashPettyCashNewRouteImport } from './routes/(workspace)/cash/petty-cash/new'
import { Route as workspaceCashPettyCashCountsRouteImport } from './routes/(workspace)/cash/petty-cash/counts'
import { Route as workspaceCashPettyCashCountRouteImport } from './routes/(workspace)/cash/petty-cash/count'
import { Route as workspaceCashPettyCashVoucherIdRouteImport } from './routes/(workspace)/cash/petty-cash/$voucherId'
import { Route as workspaceCashMovementsNewRouteImport } from './routes/(workspace)/cash/movements/new'
import { Route as workspaceCashBankAccountsNewRouteImport } from './routes/(workspace)/cash/bank-accounts/new'
import { Route as workspaceStoreAdminStorefrontIndexRouteImport } from './routes/(workspace)/store/admin/storefront/index'
import { Route as workspaceStoreAdminSamplingIndexRouteImport } from './routes/(workspace)/store/admin/sampling/index'
import { Route as workspaceStoreAdminReturnsIndexRouteImport } from './routes/(workspace)/store/admin/returns/index'
import { Route as workspaceStoreAdminReportsIndexRouteImport } from './routes/(workspace)/store/admin/reports/index'
import { Route as workspaceStoreAdminQuotesIndexRouteImport } from './routes/(workspace)/store/admin/quotes/index'
import { Route as workspaceStoreAdminProductsIndexRouteImport } from './routes/(workspace)/store/admin/products/index'
import { Route as workspaceStoreAdminPagesIndexRouteImport } from './routes/(workspace)/store/admin/pages/index'
import { Route as workspaceStoreAdminPacksIndexRouteImport } from './routes/(workspace)/store/admin/packs/index'
import { Route as workspaceStoreAdminOrdersIndexRouteImport } from './routes/(workspace)/store/admin/orders/index'
import { Route as workspaceStoreAdminCollectionsIndexRouteImport } from './routes/(workspace)/store/admin/collections/index'
import { Route as workspaceStoreAdminBuyersIndexRouteImport } from './routes/(workspace)/store/admin/buyers/index'
import { Route as workspaceSalesProformasProformaIdIndexRouteImport } from './routes/(workspace)/sales/proformas/$proformaId.index'
import { Route as workspaceSalesItemsItemIdIndexRouteImport } from './routes/(workspace)/sales/items/$itemId.index'
import { Route as workspaceSalesInvoicesInvoiceIdIndexRouteImport } from './routes/(workspace)/sales/invoices/$invoiceId.index'
import { Route as workspaceSalesCustomersCustomerIdIndexRouteImport } from './routes/(workspace)/sales/customers/$customerId.index'
import { Route as workspaceProcurementVendorsVendorIdIndexRouteImport } from './routes/(workspace)/procurement/vendors/$vendorId.index'
import { Route as workspaceProcurementPurchaseOrdersPoIdIndexRouteImport } from './routes/(workspace)/procurement/purchase-orders/$poId.index'
import { Route as workspaceProcurementGoodsReceiptsGrnIdIndexRouteImport } from './routes/(workspace)/procurement/goods-receipts/$grnId.index'
import { Route as workspaceProcurementBillsBillIdIndexRouteImport } from './routes/(workspace)/procurement/bills/$billId.index'
import { Route as workspacePayrollEmployeesEmployeeIdIndexRouteImport } from './routes/(workspace)/payroll/employees/$employeeId.index'
import { Route as workspaceMerchandisingStylesStyleIdIndexRouteImport } from './routes/(workspace)/merchandising/styles/$styleId.index'
import { Route as workspaceMerchandisingOrdersOrderIdIndexRouteImport } from './routes/(workspace)/merchandising/orders/$orderId.index'
import { Route as workspaceInventoryWarehousesWarehouseIdIndexRouteImport } from './routes/(workspace)/inventory/warehouses/$warehouseId.index'
import { Route as workspaceCashBankAccountsBankAccountIdIndexRouteImport } from './routes/(workspace)/cash/bank-accounts/$bankAccountId.index'
import { Route as workspaceStoreAdminQuotesNewRouteImport } from './routes/(workspace)/store/admin/quotes/new'
import { Route as workspaceStoreAdminProductsNewRouteImport } from './routes/(workspace)/store/admin/products/new'
import { Route as workspaceStoreAdminCollectionsNewRouteImport } from './routes/(workspace)/store/admin/collections/new'
import { Route as workspaceSamplingStylesStyleIdSamplesRouteImport } from './routes/(workspace)/sampling/styles/$styleId.samples'
import { Route as workspaceSalesProformasProformaIdEditRouteImport } from './routes/(workspace)/sales/proformas_.$proformaId.edit'
import { Route as workspaceSalesItemsItemIdEditRouteImport } from './routes/(workspace)/sales/items/$itemId.edit'
import { Route as workspaceSalesInvoicesInvoiceIdEditRouteImport } from './routes/(workspace)/sales/invoices_.$invoiceId.edit'
import { Route as workspaceSalesCustomersCustomerIdLedgerRouteImport } from './routes/(workspace)/sales/customers/$customerId.ledger'
import { Route as workspaceSalesCustomersCustomerIdEditRouteImport } from './routes/(workspace)/sales/customers/$customerId.edit'
import { Route as workspaceQualityStylesStyleIdQcRouteImport } from './routes/(workspace)/quality/styles/$styleId.qc'
import { Route as workspaceProductionStylesStyleIdProductionRouteImport } from './routes/(workspace)/production/styles/$styleId.production'
import { Route as workspaceProcurementVendorsVendorIdEditRouteImport } from './routes/(workspace)/procurement/vendors/$vendorId.edit'
import { Route as workspaceProcurementPurchaseOrdersPoIdEditRouteImport } from './routes/(workspace)/procurement/purchase-orders/$poId.edit'
import { Route as workspaceProcurementGoodsReceiptsGrnIdEditRouteImport } from './routes/(workspace)/procurement/goods-receipts/$grnId.edit'
import { Route as workspaceProcurementBillsBillIdEditRouteImport } from './routes/(workspace)/procurement/bills/$billId.edit'
import { Route as workspacePayrollEmployeesEmployeeIdEditRouteImport } from './routes/(workspace)/payroll/employees/$employeeId.edit'
import { Route as workspaceMerchandisingStylesStyleIdVisualRouteImport } from './routes/(workspace)/merchandising/styles/$styleId.visual'
import { Route as workspaceMerchandisingStylesStyleIdTimelineRouteImport } from './routes/(workspace)/merchandising/styles/$styleId.timeline'
import { Route as workspaceMerchandisingStylesStyleIdOverviewRouteImport } from './routes/(workspace)/merchandising/styles/$styleId.overview'
import { Route as workspaceMerchandisingStylesStyleIdMaterialsRouteImport } from './routes/(workspace)/merchandising/styles/$styleId.materials'
import { Route as workspaceMerchandisingStylesStyleIdDispatchRouteImport } from './routes/(workspace)/merchandising/styles/$styleId.dispatch'
import { Route as workspaceMerchandisingStylesStyleIdCostingRouteImport } from './routes/(workspace)/merchandising/styles/$styleId.costing'
import { Route as workspaceMerchandisingOrdersOrderIdEditRouteImport } from './routes/(workspace)/merchandising/orders/$orderId.edit'
import { Route as workspaceInventoryWarehousesWarehouseIdEditRouteImport } from './routes/(workspace)/inventory/warehouses/$warehouseId.edit'
import { Route as workspaceCashBankAccountsBankAccountIdEditRouteImport } from './routes/(workspace)/cash/bank-accounts/$bankAccountId.edit'
import { Route as workspaceStoreAdminStorefrontAppearanceIdIndexRouteImport } from './routes/(workspace)/store/admin/storefront/$appearanceId/index'
import { Route as workspaceStoreAdminSamplingSampleIdIndexRouteImport } from './routes/(workspace)/store/admin/sampling/$sampleId/index'
import { Route as workspaceStoreAdminQuotesQuoteIdIndexRouteImport } from './routes/(workspace)/store/admin/quotes/$quoteId/index'
import { Route as workspaceStoreAdminProductsListingIdIndexRouteImport } from './routes/(workspace)/store/admin/products/$listingId/index'
import { Route as workspaceStoreAdminOrdersOrderIdIndexRouteImport } from './routes/(workspace)/store/admin/orders/$orderId/index'
import { Route as workspaceStoreAdminCollectionsCollectionIdIndexRouteImport } from './routes/(workspace)/store/admin/collections/$collectionId/index'
import { Route as workspaceStoreAdminBuyersBuyerIdIndexRouteImport } from './routes/(workspace)/store/admin/buyers/$buyerId/index'
import { Route as workspaceMerchandisingStylesStyleIdDesignIndexRouteImport } from './routes/(workspace)/merchandising/styles/$styleId.design.index'
import { Route as workspaceStoreAdminProductsListingIdEditRouteImport } from './routes/(workspace)/store/admin/products/$listingId/edit'
import { Route as workspaceStoreAdminCollectionsCollectionIdEditRouteImport } from './routes/(workspace)/store/admin/collections/$collectionId/edit'
import { Route as workspaceMerchandisingStylesStyleIdDesignPackRouteImport } from './routes/(workspace)/merchandising/styles/$styleId.design.pack'
import { Route as workspaceStoreAdminStorefrontTemplatesTemplateKeyIndexRouteImport } from './routes/(workspace)/store/admin/storefront/templates/$templateKey/index'
import { Route as workspaceStoreAdminStorefrontAppearanceIdPreviewIndexRouteImport } from './routes/(workspace)/store/admin/storefront/$appearanceId/preview/index'

const SubscriptionEndedRoute = SubscriptionEndedRouteImport.update({
  id: '/subscription-ended',
  path: '/subscription-ended',
  getParentRoute: () => rootRouteImport,
} as any)
const PosRoute = PosRouteImport.update({
  id: '/pos',
  path: '/pos',
  getParentRoute: () => rootRouteImport,
} as any)
const LaunchRoute = LaunchRouteImport.update({
  id: '/launch',
  path: '/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const workspaceRouteRoute = workspaceRouteRouteImport.update({
  id: '/(workspace)',
  getParentRoute: () => rootRouteImport,
} as any)
const StationIndexRoute = StationIndexRouteImport.update({
  id: '/station/',
  path: '/station/',
  getParentRoute: () => rootRouteImport,
} as any)
const workspaceIndexRoute = workspaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => workspaceRouteRoute,
} as any)
const workspaceApprovalsRoute = workspaceApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => workspaceRouteRoute,
} as any)
const workspaceReportsRouteRoute = workspaceReportsRouteRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => workspaceRouteRoute,
} as any)
const workspacePayrollRouteRoute = workspacePayrollRouteRouteImport.update({
  id: '/payroll',
  path: '/payroll',
  getParentRoute: () => workspaceRouteRoute,
} as any)
const workspaceDocumentsRouteRoute = workspaceDocumentsRouteRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => workspaceRouteRoute,
} as any)
const workspaceSettingsIndexRoute = workspaceSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => workspaceRouteRoute,
} as any)
const workspaceReportsIndexRoute = workspaceReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => workspaceReportsRouteRoute,
} as any)
const workspaceProfileIndexRoute = workspaceProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => workspaceRouteRoute,
} as any)
const workspacePayrollIndexRoute = workspacePayrollIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => workspacePayrollRouteRoute,
} as any)
const workspaceDocumentsIndexRoute = workspaceDocumentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => workspaceDocumentsRouteRoute,
} as any)
const workspaceAskIndexRoute = workspaceAskIndexRouteImport.update({
  id: '/ask/',
  path: '/ask/',
  getParentRoute: () => workspaceRouteRoute,
} as any)
const workspaceApprovalsIndexRoute = workspaceApprovalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => workspaceApprovalsRoute,
} as any)
const authSignInIndexRoute = authSignInIndexRouteImport.update({
  id: '/(auth)/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => rootRouteImport,
} as any)
const workspaceReportsNewRoute = workspaceReportsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => workspaceReportsRouteRoute,
} as any)
const workspaceReportsReportKeyRoute =
  workspaceReportsReportKeyRouteImport.update({
    id: '/$reportKey',
    path: '/$reportKey',
    getParentRoute: () => workspaceReportsRouteRoute,
  } as any)
const workspaceAskChatIdRoute = workspaceAskChatIdRouteImport.update({
  id: '/ask/$chatId',
  path: '/ask/$chatId',
  getParentRoute: () => workspaceRouteRoute,
} as any)
const workspaceApprovalsApprovalIdRoute =
  workspaceApprovalsApprovalIdRouteImport.update({
    id: '/$approvalId',
    path: '/$approvalId',
    getParentRoute: () => workspaceApprovalsRoute,
  } as any)
const authSignInOtpRoute = authSignInOtpRouteImport.update({
  id: '/(auth)/sign-in/otp',
  path: '/sign-in/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authOnboardingWorkspaceRoute = authOnboardingWorkspaceRouteImport.update({
  id: '/(auth)/onboarding/workspace',
  path: '/onboarding/workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const authOnboardingTallyRoute = authOnboardingTallyRouteImport.update({
  id: '/(auth)/onboarding/tally',
  path: '/onboarding/tally',
  getParentRoute: () => rootRouteImport,
} as any)
const authOnboardingDoneRoute = authOnboardingDoneRouteImport.update({
  id: '/(auth)/onboarding/done',
  path: '/onboarding/done',
  getParentRoute: () => rootRouteImport,
} as any)
const authOnboardingAccountRoute = authOnboardingAccountRouteImport.update({
  id: '/(auth)/onboarding/account',
  path: '/onboarding/account',
  getParentRoute: () => rootRouteImport,
} as any)
const authJoinTokenRoute = authJoinTokenRouteImport.update({
  id: '/(auth)/join/$token',
  path: '/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const workspaceInventoryStockTransfersRouteRoute =
  workspaceInventoryStockTransfersRouteRouteImport.update({
    id: '/inventory/stock-transfers',
    path: '/inventory/stock-transfers',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceComplianceBooksRouteRoute =
  workspaceComplianceBooksRouteRouteImport.update({
    id: '/compliance/books',
    path: '/compliance/books',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceCashTransfersRouteRoute =
  workspaceCashTransfersRouteRouteImport.update({
    id: '/cash/transfers',
    path: '/cash/transfers',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceCashReconcileRouteRoute =
  workspaceCashReconcileRouteRouteImport.update({
    id: '/cash/reconcile',
    path: '/cash/reconcile',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceCashPettyCashRouteRoute =
  workspaceCashPettyCashRouteRouteImport.update({
    id: '/cash/petty-cash',
    path: '/cash/petty-cash',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceCashMovementsRouteRoute =
  workspaceCashMovementsRouteRouteImport.update({
    id: '/cash/movements',
    path: '/cash/movements',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminIndexRoute =
  workspaceStoreAdminIndexRouteImport.update({
    id: '/store/admin/',
    path: '/store/admin/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsTemplatesIndexRoute =
  workspaceSettingsTemplatesIndexRouteImport.update({
    id: '/settings/templates/',
    path: '/settings/templates/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsTeamIndexRoute =
  workspaceSettingsTeamIndexRouteImport.update({
    id: '/settings/team/',
    path: '/settings/team/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsSubscriptionIndexRoute =
  workspaceSettingsSubscriptionIndexRouteImport.update({
    id: '/settings/subscription/',
    path: '/settings/subscription/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsRolesIndexRoute =
  workspaceSettingsRolesIndexRouteImport.update({
    id: '/settings/roles/',
    path: '/settings/roles/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsRecurringIndexRoute =
  workspaceSettingsRecurringIndexRouteImport.update({
    id: '/settings/recurring/',
    path: '/settings/recurring/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsProfileIndexRoute =
  workspaceSettingsProfileIndexRouteImport.update({
    id: '/settings/profile/',
    path: '/settings/profile/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsNumberingIndexRoute =
  workspaceSettingsNumberingIndexRouteImport.update({
    id: '/settings/numbering/',
    path: '/settings/numbering/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsNotificationsIndexRoute =
  workspaceSettingsNotificationsIndexRouteImport.update({
    id: '/settings/notifications/',
    path: '/settings/notifications/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsIntegrationsIndexRoute =
  workspaceSettingsIntegrationsIndexRouteImport.update({
    id: '/settings/integrations/',
    path: '/settings/integrations/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsGstinIndexRoute =
  workspaceSettingsGstinIndexRouteImport.update({
    id: '/settings/gstin/',
    path: '/settings/gstin/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsCompanyIndexRoute =
  workspaceSettingsCompanyIndexRouteImport.update({
    id: '/settings/company/',
    path: '/settings/company/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsBillingIndexRoute =
  workspaceSettingsBillingIndexRouteImport.update({
    id: '/settings/billing/',
    path: '/settings/billing/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsAssistantIndexRoute =
  workspaceSettingsAssistantIndexRouteImport.update({
    id: '/settings/assistant/',
    path: '/settings/assistant/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsApprovalsIndexRoute =
  workspaceSettingsApprovalsIndexRouteImport.update({
    id: '/settings/approvals/',
    path: '/settings/approvals/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSettingsAboutIndexRoute =
  workspaceSettingsAboutIndexRouteImport.update({
    id: '/settings/about/',
    path: '/settings/about/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesReceiptsIndexRoute =
  workspaceSalesReceiptsIndexRouteImport.update({
    id: '/sales/receipts/',
    path: '/sales/receipts/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesProformasIndexRoute =
  workspaceSalesProformasIndexRouteImport.update({
    id: '/sales/proformas/',
    path: '/sales/proformas/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesItemsIndexRoute =
  workspaceSalesItemsIndexRouteImport.update({
    id: '/sales/items/',
    path: '/sales/items/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesInvoicesIndexRoute =
  workspaceSalesInvoicesIndexRouteImport.update({
    id: '/sales/invoices/',
    path: '/sales/invoices/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesCustomersIndexRoute =
  workspaceSalesCustomersIndexRouteImport.update({
    id: '/sales/customers/',
    path: '/sales/customers/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesCollectionsIndexRoute =
  workspaceSalesCollectionsIndexRouteImport.update({
    id: '/sales/collections/',
    path: '/sales/collections/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceRecordsAuditLogIndexRoute =
  workspaceRecordsAuditLogIndexRouteImport.update({
    id: '/records/audit-log/',
    path: '/records/audit-log/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProductionFloorIndexRoute =
  workspaceProductionFloorIndexRouteImport.update({
    id: '/production/floor/',
    path: '/production/floor/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementVendorsIndexRoute =
  workspaceProcurementVendorsIndexRouteImport.update({
    id: '/procurement/vendors/',
    path: '/procurement/vendors/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementPurchaseOrdersIndexRoute =
  workspaceProcurementPurchaseOrdersIndexRouteImport.update({
    id: '/procurement/purchase-orders/',
    path: '/procurement/purchase-orders/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementPaymentsIndexRoute =
  workspaceProcurementPaymentsIndexRouteImport.update({
    id: '/procurement/payments/',
    path: '/procurement/payments/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementGoodsReceiptsIndexRoute =
  workspaceProcurementGoodsReceiptsIndexRouteImport.update({
    id: '/procurement/goods-receipts/',
    path: '/procurement/goods-receipts/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementBillsIndexRoute =
  workspaceProcurementBillsIndexRouteImport.update({
    id: '/procurement/bills/',
    path: '/procurement/bills/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspacePosShiftsIndexRoute = workspacePosShiftsIndexRouteImport.update({
  id: '/pos/shifts/',
  path: '/pos/shifts/',
  getParentRoute: () => workspaceRouteRoute,
} as any)
const workspacePayrollEmployeesIndexRoute =
  workspacePayrollEmployeesIndexRouteImport.update({
    id: '/employees/',
    path: '/employees/',
    getParentRoute: () => workspacePayrollRouteRoute,
  } as any)
const workspacePayrollRunIdIndexRoute =
  workspacePayrollRunIdIndexRouteImport.update({
    id: '/$runId/',
    path: '/$runId/',
    getParentRoute: () => workspacePayrollRouteRoute,
  } as any)
const workspaceMerchandisingStylesIndexRoute =
  workspaceMerchandisingStylesIndexRouteImport.update({
    id: '/merchandising/styles/',
    path: '/merchandising/styles/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceMerchandisingRisksIndexRoute =
  workspaceMerchandisingRisksIndexRouteImport.update({
    id: '/merchandising/risks/',
    path: '/merchandising/risks/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceMerchandisingOrdersIndexRoute =
  workspaceMerchandisingOrdersIndexRouteImport.update({
    id: '/merchandising/orders/',
    path: '/merchandising/orders/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceInventoryWarehousesIndexRoute =
  workspaceInventoryWarehousesIndexRouteImport.update({
    id: '/inventory/warehouses/',
    path: '/inventory/warehouses/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceInventoryStockIndexRoute =
  workspaceInventoryStockIndexRouteImport.update({
    id: '/inventory/stock/',
    path: '/inventory/stock/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceInventoryStockTransfersIndexRoute =
  workspaceInventoryStockTransfersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => workspaceInventoryStockTransfersRouteRoute,
  } as any)
const workspaceInventoryStockAdjustmentsIndexRoute =
  workspaceInventoryStockAdjustmentsIndexRouteImport.update({
    id: '/inventory/stock-adjustments/',
    path: '/inventory/stock-adjustments/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceComplianceTdsIndexRoute =
  workspaceComplianceTdsIndexRouteImport.update({
    id: '/compliance/tds/',
    path: '/compliance/tds/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceComplianceItc04IndexRoute =
  workspaceComplianceItc04IndexRouteImport.update({
    id: '/compliance/itc04/',
    path: '/compliance/itc04/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceComplianceGstReturnsIndexRoute =
  workspaceComplianceGstReturnsIndexRouteImport.update({
    id: '/compliance/gst-returns/',
    path: '/compliance/gst-returns/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceComplianceBooksIndexRoute =
  workspaceComplianceBooksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => workspaceComplianceBooksRouteRoute,
  } as any)
const workspaceCashTransfersIndexRoute =
  workspaceCashTransfersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => workspaceCashTransfersRouteRoute,
  } as any)
const workspaceCashReconcileIndexRoute =
  workspaceCashReconcileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => workspaceCashReconcileRouteRoute,
  } as any)
const workspaceCashPettyCashIndexRoute =
  workspaceCashPettyCashIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => workspaceCashPettyCashRouteRoute,
  } as any)
const workspaceCashBankAccountsIndexRoute =
  workspaceCashBankAccountsIndexRouteImport.update({
    id: '/cash/bank-accounts/',
    path: '/cash/bank-accounts/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesReceiptsReceiptIdRoute =
  workspaceSalesReceiptsReceiptIdRouteImport.update({
    id: '/sales/receipts/$receiptId',
    path: '/sales/receipts/$receiptId',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesProformasNewRoute =
  workspaceSalesProformasNewRouteImport.update({
    id: '/sales/proformas/new',
    path: '/sales/proformas/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesItemsNewRoute = workspaceSalesItemsNewRouteImport.update({
  id: '/sales/items/new',
  path: '/sales/items/new',
  getParentRoute: () => workspaceRouteRoute,
} as any)
const workspaceSalesInvoicesNewRoute =
  workspaceSalesInvoicesNewRouteImport.update({
    id: '/sales/invoices/new',
    path: '/sales/invoices/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesCustomersNewRoute =
  workspaceSalesCustomersNewRouteImport.update({
    id: '/sales/customers/new',
    path: '/sales/customers/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProductionFloorInwardRoute =
  workspaceProductionFloorInwardRouteImport.update({
    id: '/production/floor/inward',
    path: '/production/floor/inward',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProductionFloorStageRoute =
  workspaceProductionFloorStageRouteImport.update({
    id: '/production/floor/$stage',
    path: '/production/floor/$stage',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementVendorsNewRoute =
  workspaceProcurementVendorsNewRouteImport.update({
    id: '/procurement/vendors/new',
    path: '/procurement/vendors/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementPurchaseOrdersNewRoute =
  workspaceProcurementPurchaseOrdersNewRouteImport.update({
    id: '/procurement/purchase-orders/new',
    path: '/procurement/purchase-orders/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementGoodsReceiptsNewRoute =
  workspaceProcurementGoodsReceiptsNewRouteImport.update({
    id: '/procurement/goods-receipts/new',
    path: '/procurement/goods-receipts/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementBillsNewRoute =
  workspaceProcurementBillsNewRouteImport.update({
    id: '/procurement/bills/new',
    path: '/procurement/bills/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspacePayrollEmployeesNewRoute =
  workspacePayrollEmployeesNewRouteImport.update({
    id: '/employees/new',
    path: '/employees/new',
    getParentRoute: () => workspacePayrollRouteRoute,
  } as any)
const workspaceMerchandisingStylesNewRoute =
  workspaceMerchandisingStylesNewRouteImport.update({
    id: '/merchandising/styles/new',
    path: '/merchandising/styles/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceMerchandisingOrdersNewRoute =
  workspaceMerchandisingOrdersNewRouteImport.update({
    id: '/merchandising/orders/new',
    path: '/merchandising/orders/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceInventoryWarehousesNewRoute =
  workspaceInventoryWarehousesNewRouteImport.update({
    id: '/inventory/warehouses/new',
    path: '/inventory/warehouses/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceInventoryStockOpeningRoute =
  workspaceInventoryStockOpeningRouteImport.update({
    id: '/inventory/stock/opening',
    path: '/inventory/stock/opening',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceInventoryStockTransfersNewRoute =
  workspaceInventoryStockTransfersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => workspaceInventoryStockTransfersRouteRoute,
  } as any)
const workspaceInventoryStockAdjustmentsNewRoute =
  workspaceInventoryStockAdjustmentsNewRouteImport.update({
    id: '/inventory/stock-adjustments/new',
    path: '/inventory/stock-adjustments/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceCashTransfersNewRoute =
  workspaceCashTransfersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => workspaceCashTransfersRouteRoute,
  } as any)
const workspaceCashTransfersMovementIdRoute =
  workspaceCashTransfersMovementIdRouteImport.update({
    id: '/$movementId',
    path: '/$movementId',
    getParentRoute: () => workspaceCashTransfersRouteRoute,
  } as any)
const workspaceCashPettyCashReplenishRoute =
  workspaceCashPettyCashReplenishRouteImport.update({
    id: '/replenish',
    path: '/replenish',
    getParentRoute: () => workspaceCashPettyCashRouteRoute,
  } as any)
const workspaceCashPettyCashNewRoute =
  workspaceCashPettyCashNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => workspaceCashPettyCashRouteRoute,
  } as any)
const workspaceCashPettyCashCountsRoute =
  workspaceCashPettyCashCountsRouteImport.update({
    id: '/counts',
    path: '/counts',
    getParentRoute: () => workspaceCashPettyCashRouteRoute,
  } as any)
const workspaceCashPettyCashCountRoute =
  workspaceCashPettyCashCountRouteImport.update({
    id: '/count',
    path: '/count',
    getParentRoute: () => workspaceCashPettyCashRouteRoute,
  } as any)
const workspaceCashPettyCashVoucherIdRoute =
  workspaceCashPettyCashVoucherIdRouteImport.update({
    id: '/$voucherId',
    path: '/$voucherId',
    getParentRoute: () => workspaceCashPettyCashRouteRoute,
  } as any)
const workspaceCashMovementsNewRoute =
  workspaceCashMovementsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => workspaceCashMovementsRouteRoute,
  } as any)
const workspaceCashBankAccountsNewRoute =
  workspaceCashBankAccountsNewRouteImport.update({
    id: '/cash/bank-accounts/new',
    path: '/cash/bank-accounts/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminStorefrontIndexRoute =
  workspaceStoreAdminStorefrontIndexRouteImport.update({
    id: '/store/admin/storefront/',
    path: '/store/admin/storefront/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminSamplingIndexRoute =
  workspaceStoreAdminSamplingIndexRouteImport.update({
    id: '/store/admin/sampling/',
    path: '/store/admin/sampling/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminReturnsIndexRoute =
  workspaceStoreAdminReturnsIndexRouteImport.update({
    id: '/store/admin/returns/',
    path: '/store/admin/returns/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminReportsIndexRoute =
  workspaceStoreAdminReportsIndexRouteImport.update({
    id: '/store/admin/reports/',
    path: '/store/admin/reports/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminQuotesIndexRoute =
  workspaceStoreAdminQuotesIndexRouteImport.update({
    id: '/store/admin/quotes/',
    path: '/store/admin/quotes/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminProductsIndexRoute =
  workspaceStoreAdminProductsIndexRouteImport.update({
    id: '/store/admin/products/',
    path: '/store/admin/products/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminPagesIndexRoute =
  workspaceStoreAdminPagesIndexRouteImport.update({
    id: '/store/admin/pages/',
    path: '/store/admin/pages/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminPacksIndexRoute =
  workspaceStoreAdminPacksIndexRouteImport.update({
    id: '/store/admin/packs/',
    path: '/store/admin/packs/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminOrdersIndexRoute =
  workspaceStoreAdminOrdersIndexRouteImport.update({
    id: '/store/admin/orders/',
    path: '/store/admin/orders/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminCollectionsIndexRoute =
  workspaceStoreAdminCollectionsIndexRouteImport.update({
    id: '/store/admin/collections/',
    path: '/store/admin/collections/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminBuyersIndexRoute =
  workspaceStoreAdminBuyersIndexRouteImport.update({
    id: '/store/admin/buyers/',
    path: '/store/admin/buyers/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesProformasProformaIdIndexRoute =
  workspaceSalesProformasProformaIdIndexRouteImport.update({
    id: '/sales/proformas/$proformaId/',
    path: '/sales/proformas/$proformaId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesItemsItemIdIndexRoute =
  workspaceSalesItemsItemIdIndexRouteImport.update({
    id: '/sales/items/$itemId/',
    path: '/sales/items/$itemId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesInvoicesInvoiceIdIndexRoute =
  workspaceSalesInvoicesInvoiceIdIndexRouteImport.update({
    id: '/sales/invoices/$invoiceId/',
    path: '/sales/invoices/$invoiceId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesCustomersCustomerIdIndexRoute =
  workspaceSalesCustomersCustomerIdIndexRouteImport.update({
    id: '/sales/customers/$customerId/',
    path: '/sales/customers/$customerId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementVendorsVendorIdIndexRoute =
  workspaceProcurementVendorsVendorIdIndexRouteImport.update({
    id: '/procurement/vendors/$vendorId/',
    path: '/procurement/vendors/$vendorId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementPurchaseOrdersPoIdIndexRoute =
  workspaceProcurementPurchaseOrdersPoIdIndexRouteImport.update({
    id: '/procurement/purchase-orders/$poId/',
    path: '/procurement/purchase-orders/$poId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementGoodsReceiptsGrnIdIndexRoute =
  workspaceProcurementGoodsReceiptsGrnIdIndexRouteImport.update({
    id: '/procurement/goods-receipts/$grnId/',
    path: '/procurement/goods-receipts/$grnId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementBillsBillIdIndexRoute =
  workspaceProcurementBillsBillIdIndexRouteImport.update({
    id: '/procurement/bills/$billId/',
    path: '/procurement/bills/$billId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspacePayrollEmployeesEmployeeIdIndexRoute =
  workspacePayrollEmployeesEmployeeIdIndexRouteImport.update({
    id: '/employees/$employeeId/',
    path: '/employees/$employeeId/',
    getParentRoute: () => workspacePayrollRouteRoute,
  } as any)
const workspaceMerchandisingStylesStyleIdIndexRoute =
  workspaceMerchandisingStylesStyleIdIndexRouteImport.update({
    id: '/merchandising/styles/$styleId/',
    path: '/merchandising/styles/$styleId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceMerchandisingOrdersOrderIdIndexRoute =
  workspaceMerchandisingOrdersOrderIdIndexRouteImport.update({
    id: '/merchandising/orders/$orderId/',
    path: '/merchandising/orders/$orderId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceInventoryWarehousesWarehouseIdIndexRoute =
  workspaceInventoryWarehousesWarehouseIdIndexRouteImport.update({
    id: '/inventory/warehouses/$warehouseId/',
    path: '/inventory/warehouses/$warehouseId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceCashBankAccountsBankAccountIdIndexRoute =
  workspaceCashBankAccountsBankAccountIdIndexRouteImport.update({
    id: '/cash/bank-accounts/$bankAccountId/',
    path: '/cash/bank-accounts/$bankAccountId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminQuotesNewRoute =
  workspaceStoreAdminQuotesNewRouteImport.update({
    id: '/store/admin/quotes/new',
    path: '/store/admin/quotes/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminProductsNewRoute =
  workspaceStoreAdminProductsNewRouteImport.update({
    id: '/store/admin/products/new',
    path: '/store/admin/products/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminCollectionsNewRoute =
  workspaceStoreAdminCollectionsNewRouteImport.update({
    id: '/store/admin/collections/new',
    path: '/store/admin/collections/new',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSamplingStylesStyleIdSamplesRoute =
  workspaceSamplingStylesStyleIdSamplesRouteImport.update({
    id: '/sampling/styles/$styleId/samples',
    path: '/sampling/styles/$styleId/samples',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesProformasProformaIdEditRoute =
  workspaceSalesProformasProformaIdEditRouteImport.update({
    id: '/sales/proformas_/$proformaId/edit',
    path: '/sales/proformas/$proformaId/edit',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesItemsItemIdEditRoute =
  workspaceSalesItemsItemIdEditRouteImport.update({
    id: '/sales/items/$itemId/edit',
    path: '/sales/items/$itemId/edit',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesInvoicesInvoiceIdEditRoute =
  workspaceSalesInvoicesInvoiceIdEditRouteImport.update({
    id: '/sales/invoices_/$invoiceId/edit',
    path: '/sales/invoices/$invoiceId/edit',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesCustomersCustomerIdLedgerRoute =
  workspaceSalesCustomersCustomerIdLedgerRouteImport.update({
    id: '/sales/customers/$customerId/ledger',
    path: '/sales/customers/$customerId/ledger',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceSalesCustomersCustomerIdEditRoute =
  workspaceSalesCustomersCustomerIdEditRouteImport.update({
    id: '/sales/customers/$customerId/edit',
    path: '/sales/customers/$customerId/edit',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceQualityStylesStyleIdQcRoute =
  workspaceQualityStylesStyleIdQcRouteImport.update({
    id: '/quality/styles/$styleId/qc',
    path: '/quality/styles/$styleId/qc',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProductionStylesStyleIdProductionRoute =
  workspaceProductionStylesStyleIdProductionRouteImport.update({
    id: '/production/styles/$styleId/production',
    path: '/production/styles/$styleId/production',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementVendorsVendorIdEditRoute =
  workspaceProcurementVendorsVendorIdEditRouteImport.update({
    id: '/procurement/vendors/$vendorId/edit',
    path: '/procurement/vendors/$vendorId/edit',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementPurchaseOrdersPoIdEditRoute =
  workspaceProcurementPurchaseOrdersPoIdEditRouteImport.update({
    id: '/procurement/purchase-orders/$poId/edit',
    path: '/procurement/purchase-orders/$poId/edit',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementGoodsReceiptsGrnIdEditRoute =
  workspaceProcurementGoodsReceiptsGrnIdEditRouteImport.update({
    id: '/procurement/goods-receipts/$grnId/edit',
    path: '/procurement/goods-receipts/$grnId/edit',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceProcurementBillsBillIdEditRoute =
  workspaceProcurementBillsBillIdEditRouteImport.update({
    id: '/procurement/bills/$billId/edit',
    path: '/procurement/bills/$billId/edit',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspacePayrollEmployeesEmployeeIdEditRoute =
  workspacePayrollEmployeesEmployeeIdEditRouteImport.update({
    id: '/employees/$employeeId/edit',
    path: '/employees/$employeeId/edit',
    getParentRoute: () => workspacePayrollRouteRoute,
  } as any)
const workspaceMerchandisingStylesStyleIdVisualRoute =
  workspaceMerchandisingStylesStyleIdVisualRouteImport.update({
    id: '/merchandising/styles/$styleId/visual',
    path: '/merchandising/styles/$styleId/visual',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceMerchandisingStylesStyleIdTimelineRoute =
  workspaceMerchandisingStylesStyleIdTimelineRouteImport.update({
    id: '/merchandising/styles/$styleId/timeline',
    path: '/merchandising/styles/$styleId/timeline',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceMerchandisingStylesStyleIdOverviewRoute =
  workspaceMerchandisingStylesStyleIdOverviewRouteImport.update({
    id: '/merchandising/styles/$styleId/overview',
    path: '/merchandising/styles/$styleId/overview',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceMerchandisingStylesStyleIdMaterialsRoute =
  workspaceMerchandisingStylesStyleIdMaterialsRouteImport.update({
    id: '/merchandising/styles/$styleId/materials',
    path: '/merchandising/styles/$styleId/materials',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceMerchandisingStylesStyleIdDispatchRoute =
  workspaceMerchandisingStylesStyleIdDispatchRouteImport.update({
    id: '/merchandising/styles/$styleId/dispatch',
    path: '/merchandising/styles/$styleId/dispatch',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceMerchandisingStylesStyleIdCostingRoute =
  workspaceMerchandisingStylesStyleIdCostingRouteImport.update({
    id: '/merchandising/styles/$styleId/costing',
    path: '/merchandising/styles/$styleId/costing',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceMerchandisingOrdersOrderIdEditRoute =
  workspaceMerchandisingOrdersOrderIdEditRouteImport.update({
    id: '/merchandising/orders/$orderId/edit',
    path: '/merchandising/orders/$orderId/edit',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceInventoryWarehousesWarehouseIdEditRoute =
  workspaceInventoryWarehousesWarehouseIdEditRouteImport.update({
    id: '/inventory/warehouses/$warehouseId/edit',
    path: '/inventory/warehouses/$warehouseId/edit',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceCashBankAccountsBankAccountIdEditRoute =
  workspaceCashBankAccountsBankAccountIdEditRouteImport.update({
    id: '/cash/bank-accounts/$bankAccountId/edit',
    path: '/cash/bank-accounts/$bankAccountId/edit',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminStorefrontAppearanceIdIndexRoute =
  workspaceStoreAdminStorefrontAppearanceIdIndexRouteImport.update({
    id: '/store/admin/storefront/$appearanceId/',
    path: '/store/admin/storefront/$appearanceId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminSamplingSampleIdIndexRoute =
  workspaceStoreAdminSamplingSampleIdIndexRouteImport.update({
    id: '/store/admin/sampling/$sampleId/',
    path: '/store/admin/sampling/$sampleId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminQuotesQuoteIdIndexRoute =
  workspaceStoreAdminQuotesQuoteIdIndexRouteImport.update({
    id: '/store/admin/quotes/$quoteId/',
    path: '/store/admin/quotes/$quoteId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminProductsListingIdIndexRoute =
  workspaceStoreAdminProductsListingIdIndexRouteImport.update({
    id: '/store/admin/products/$listingId/',
    path: '/store/admin/products/$listingId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminOrdersOrderIdIndexRoute =
  workspaceStoreAdminOrdersOrderIdIndexRouteImport.update({
    id: '/store/admin/orders/$orderId/',
    path: '/store/admin/orders/$orderId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminCollectionsCollectionIdIndexRoute =
  workspaceStoreAdminCollectionsCollectionIdIndexRouteImport.update({
    id: '/store/admin/collections/$collectionId/',
    path: '/store/admin/collections/$collectionId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminBuyersBuyerIdIndexRoute =
  workspaceStoreAdminBuyersBuyerIdIndexRouteImport.update({
    id: '/store/admin/buyers/$buyerId/',
    path: '/store/admin/buyers/$buyerId/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceMerchandisingStylesStyleIdDesignIndexRoute =
  workspaceMerchandisingStylesStyleIdDesignIndexRouteImport.update({
    id: '/merchandising/styles/$styleId/design/',
    path: '/merchandising/styles/$styleId/design/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminProductsListingIdEditRoute =
  workspaceStoreAdminProductsListingIdEditRouteImport.update({
    id: '/store/admin/products/$listingId/edit',
    path: '/store/admin/products/$listingId/edit',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminCollectionsCollectionIdEditRoute =
  workspaceStoreAdminCollectionsCollectionIdEditRouteImport.update({
    id: '/store/admin/collections/$collectionId/edit',
    path: '/store/admin/collections/$collectionId/edit',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceMerchandisingStylesStyleIdDesignPackRoute =
  workspaceMerchandisingStylesStyleIdDesignPackRouteImport.update({
    id: '/merchandising/styles/$styleId/design/pack',
    path: '/merchandising/styles/$styleId/design/pack',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminStorefrontTemplatesTemplateKeyIndexRoute =
  workspaceStoreAdminStorefrontTemplatesTemplateKeyIndexRouteImport.update({
    id: '/store/admin/storefront/templates/$templateKey/',
    path: '/store/admin/storefront/templates/$templateKey/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)
const workspaceStoreAdminStorefrontAppearanceIdPreviewIndexRoute =
  workspaceStoreAdminStorefrontAppearanceIdPreviewIndexRouteImport.update({
    id: '/store/admin/storefront/$appearanceId/preview/',
    path: '/store/admin/storefront/$appearanceId/preview/',
    getParentRoute: () => workspaceRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/launch': typeof LaunchRoute
  '/pos': typeof PosRoute
  '/subscription-ended': typeof SubscriptionEndedRoute
  '/documents': typeof workspaceDocumentsRouteRouteWithChildren
  '/payroll': typeof workspacePayrollRouteRouteWithChildren
  '/reports': typeof workspaceReportsRouteRouteWithChildren
  '/approvals': typeof workspaceApprovalsRouteWithChildren
  '/': typeof workspaceIndexRoute
  '/station/': typeof StationIndexRoute
  '/cash/movements': typeof workspaceCashMovementsRouteRouteWithChildren
  '/cash/petty-cash': typeof workspaceCashPettyCashRouteRouteWithChildren
  '/cash/reconcile': typeof workspaceCashReconcileRouteRouteWithChildren
  '/cash/transfers': typeof workspaceCashTransfersRouteRouteWithChildren
  '/compliance/books': typeof workspaceComplianceBooksRouteRouteWithChildren
  '/inventory/stock-transfers': typeof workspaceInventoryStockTransfersRouteRouteWithChildren
  '/join/$token': typeof authJoinTokenRoute
  '/onboarding/account': typeof authOnboardingAccountRoute
  '/onboarding/done': typeof authOnboardingDoneRoute
  '/onboarding/tally': typeof authOnboardingTallyRoute
  '/onboarding/workspace': typeof authOnboardingWorkspaceRoute
  '/sign-in/otp': typeof authSignInOtpRoute
  '/approvals/$approvalId': typeof workspaceApprovalsApprovalIdRoute
  '/ask/$chatId': typeof workspaceAskChatIdRoute
  '/reports/$reportKey': typeof workspaceReportsReportKeyRoute
  '/reports/new': typeof workspaceReportsNewRoute
  '/sign-in/': typeof authSignInIndexRoute
  '/approvals/': typeof workspaceApprovalsIndexRoute
  '/ask/': typeof workspaceAskIndexRoute
  '/documents/': typeof workspaceDocumentsIndexRoute
  '/payroll/': typeof workspacePayrollIndexRoute
  '/profile/': typeof workspaceProfileIndexRoute
  '/reports/': typeof workspaceReportsIndexRoute
  '/settings/': typeof workspaceSettingsIndexRoute
  '/cash/bank-accounts/new': typeof workspaceCashBankAccountsNewRoute
  '/cash/movements/new': typeof workspaceCashMovementsNewRoute
  '/cash/petty-cash/$voucherId': typeof workspaceCashPettyCashVoucherIdRoute
  '/cash/petty-cash/count': typeof workspaceCashPettyCashCountRoute
  '/cash/petty-cash/counts': typeof workspaceCashPettyCashCountsRoute
  '/cash/petty-cash/new': typeof workspaceCashPettyCashNewRoute
  '/cash/petty-cash/replenish': typeof workspaceCashPettyCashReplenishRoute
  '/cash/transfers/$movementId': typeof workspaceCashTransfersMovementIdRoute
  '/cash/transfers/new': typeof workspaceCashTransfersNewRoute
  '/inventory/stock-adjustments/new': typeof workspaceInventoryStockAdjustmentsNewRoute
  '/inventory/stock-transfers/new': typeof workspaceInventoryStockTransfersNewRoute
  '/inventory/stock/opening': typeof workspaceInventoryStockOpeningRoute
  '/inventory/warehouses/new': typeof workspaceInventoryWarehousesNewRoute
  '/merchandising/orders/new': typeof workspaceMerchandisingOrdersNewRoute
  '/merchandising/styles/new': typeof workspaceMerchandisingStylesNewRoute
  '/payroll/employees/new': typeof workspacePayrollEmployeesNewRoute
  '/procurement/bills/new': typeof workspaceProcurementBillsNewRoute
  '/procurement/goods-receipts/new': typeof workspaceProcurementGoodsReceiptsNewRoute
  '/procurement/purchase-orders/new': typeof workspaceProcurementPurchaseOrdersNewRoute
  '/procurement/vendors/new': typeof workspaceProcurementVendorsNewRoute
  '/production/floor/$stage': typeof workspaceProductionFloorStageRoute
  '/production/floor/inward': typeof workspaceProductionFloorInwardRoute
  '/sales/customers/new': typeof workspaceSalesCustomersNewRoute
  '/sales/invoices/new': typeof workspaceSalesInvoicesNewRoute
  '/sales/items/new': typeof workspaceSalesItemsNewRoute
  '/sales/proformas/new': typeof workspaceSalesProformasNewRoute
  '/sales/receipts/$receiptId': typeof workspaceSalesReceiptsReceiptIdRoute
  '/cash/bank-accounts/': typeof workspaceCashBankAccountsIndexRoute
  '/cash/petty-cash/': typeof workspaceCashPettyCashIndexRoute
  '/cash/reconcile/': typeof workspaceCashReconcileIndexRoute
  '/cash/transfers/': typeof workspaceCashTransfersIndexRoute
  '/compliance/books/': typeof workspaceComplianceBooksIndexRoute
  '/compliance/gst-returns/': typeof workspaceComplianceGstReturnsIndexRoute
  '/compliance/itc04/': typeof workspaceComplianceItc04IndexRoute
  '/compliance/tds/': typeof workspaceComplianceTdsIndexRoute
  '/inventory/stock-adjustments/': typeof workspaceInventoryStockAdjustmentsIndexRoute
  '/inventory/stock-transfers/': typeof workspaceInventoryStockTransfersIndexRoute
  '/inventory/stock/': typeof workspaceInventoryStockIndexRoute
  '/inventory/warehouses/': typeof workspaceInventoryWarehousesIndexRoute
  '/merchandising/orders/': typeof workspaceMerchandisingOrdersIndexRoute
  '/merchandising/risks/': typeof workspaceMerchandisingRisksIndexRoute
  '/merchandising/styles/': typeof workspaceMerchandisingStylesIndexRoute
  '/payroll/$runId/': typeof workspacePayrollRunIdIndexRoute
  '/payroll/employees/': typeof workspacePayrollEmployeesIndexRoute
  '/pos/shifts/': typeof workspacePosShiftsIndexRoute
  '/procurement/bills/': typeof workspaceProcurementBillsIndexRoute
  '/procurement/goods-receipts/': typeof workspaceProcurementGoodsReceiptsIndexRoute
  '/procurement/payments/': typeof workspaceProcurementPaymentsIndexRoute
  '/procurement/purchase-orders/': typeof workspaceProcurementPurchaseOrdersIndexRoute
  '/procurement/vendors/': typeof workspaceProcurementVendorsIndexRoute
  '/production/floor/': typeof workspaceProductionFloorIndexRoute
  '/records/audit-log/': typeof workspaceRecordsAuditLogIndexRoute
  '/sales/collections/': typeof workspaceSalesCollectionsIndexRoute
  '/sales/customers/': typeof workspaceSalesCustomersIndexRoute
  '/sales/invoices/': typeof workspaceSalesInvoicesIndexRoute
  '/sales/items/': typeof workspaceSalesItemsIndexRoute
  '/sales/proformas/': typeof workspaceSalesProformasIndexRoute
  '/sales/receipts/': typeof workspaceSalesReceiptsIndexRoute
  '/settings/about/': typeof workspaceSettingsAboutIndexRoute
  '/settings/approvals/': typeof workspaceSettingsApprovalsIndexRoute
  '/settings/assistant/': typeof workspaceSettingsAssistantIndexRoute
  '/settings/billing/': typeof workspaceSettingsBillingIndexRoute
  '/settings/company/': typeof workspaceSettingsCompanyIndexRoute
  '/settings/gstin/': typeof workspaceSettingsGstinIndexRoute
  '/settings/integrations/': typeof workspaceSettingsIntegrationsIndexRoute
  '/settings/notifications/': typeof workspaceSettingsNotificationsIndexRoute
  '/settings/numbering/': typeof workspaceSettingsNumberingIndexRoute
  '/settings/profile/': typeof workspaceSettingsProfileIndexRoute
  '/settings/recurring/': typeof workspaceSettingsRecurringIndexRoute
  '/settings/roles/': typeof workspaceSettingsRolesIndexRoute
  '/settings/subscription/': typeof workspaceSettingsSubscriptionIndexRoute
  '/settings/team/': typeof workspaceSettingsTeamIndexRoute
  '/settings/templates/': typeof workspaceSettingsTemplatesIndexRoute
  '/store/admin/': typeof workspaceStoreAdminIndexRoute
  '/cash/bank-accounts/$bankAccountId/edit': typeof workspaceCashBankAccountsBankAccountIdEditRoute
  '/inventory/warehouses/$warehouseId/edit': typeof workspaceInventoryWarehousesWarehouseIdEditRoute
  '/merchandising/orders/$orderId/edit': typeof workspaceMerchandisingOrdersOrderIdEditRoute
  '/merchandising/styles/$styleId/costing': typeof workspaceMerchandisingStylesStyleIdCostingRoute
  '/merchandising/styles/$styleId/dispatch': typeof workspaceMerchandisingStylesStyleIdDispatchRoute
  '/merchandising/styles/$styleId/materials': typeof workspaceMerchandisingStylesStyleIdMaterialsRoute
  '/merchandising/styles/$styleId/overview': typeof workspaceMerchandisingStylesStyleIdOverviewRoute
  '/merchandising/styles/$styleId/timeline': typeof workspaceMerchandisingStylesStyleIdTimelineRoute
  '/merchandising/styles/$styleId/visual': typeof workspaceMerchandisingStylesStyleIdVisualRoute
  '/payroll/employees/$employeeId/edit': typeof workspacePayrollEmployeesEmployeeIdEditRoute
  '/procurement/bills/$billId/edit': typeof workspaceProcurementBillsBillIdEditRoute
  '/procurement/goods-receipts/$grnId/edit': typeof workspaceProcurementGoodsReceiptsGrnIdEditRoute
  '/procurement/purchase-orders/$poId/edit': typeof workspaceProcurementPurchaseOrdersPoIdEditRoute
  '/procurement/vendors/$vendorId/edit': typeof workspaceProcurementVendorsVendorIdEditRoute
  '/production/styles/$styleId/production': typeof workspaceProductionStylesStyleIdProductionRoute
  '/quality/styles/$styleId/qc': typeof workspaceQualityStylesStyleIdQcRoute
  '/sales/customers/$customerId/edit': typeof workspaceSalesCustomersCustomerIdEditRoute
  '/sales/customers/$customerId/ledger': typeof workspaceSalesCustomersCustomerIdLedgerRoute
  '/sales/invoices/$invoiceId/edit': typeof workspaceSalesInvoicesInvoiceIdEditRoute
  '/sales/items/$itemId/edit': typeof workspaceSalesItemsItemIdEditRoute
  '/sales/proformas/$proformaId/edit': typeof workspaceSalesProformasProformaIdEditRoute
  '/sampling/styles/$styleId/samples': typeof workspaceSamplingStylesStyleIdSamplesRoute
  '/store/admin/collections/new': typeof workspaceStoreAdminCollectionsNewRoute
  '/store/admin/products/new': typeof workspaceStoreAdminProductsNewRoute
  '/store/admin/quotes/new': typeof workspaceStoreAdminQuotesNewRoute
  '/cash/bank-accounts/$bankAccountId/': typeof workspaceCashBankAccountsBankAccountIdIndexRoute
  '/inventory/warehouses/$warehouseId/': typeof workspaceInventoryWarehousesWarehouseIdIndexRoute
  '/merchandising/orders/$orderId/': typeof workspaceMerchandisingOrdersOrderIdIndexRoute
  '/merchandising/styles/$styleId/': typeof workspaceMerchandisingStylesStyleIdIndexRoute
  '/payroll/employees/$employeeId/': typeof workspacePayrollEmployeesEmployeeIdIndexRoute
  '/procurement/bills/$billId/': typeof workspaceProcurementBillsBillIdIndexRoute
  '/procurement/goods-receipts/$grnId/': typeof workspaceProcurementGoodsReceiptsGrnIdIndexRoute
  '/procurement/purchase-orders/$poId/': typeof workspaceProcurementPurchaseOrdersPoIdIndexRoute
  '/procurement/vendors/$vendorId/': typeof workspaceProcurementVendorsVendorIdIndexRoute
  '/sales/customers/$customerId/': typeof workspaceSalesCustomersCustomerIdIndexRoute
  '/sales/invoices/$invoiceId/': typeof workspaceSalesInvoicesInvoiceIdIndexRoute
  '/sales/items/$itemId/': typeof workspaceSalesItemsItemIdIndexRoute
  '/sales/proformas/$proformaId/': typeof workspaceSalesProformasProformaIdIndexRoute
  '/store/admin/buyers/': typeof workspaceStoreAdminBuyersIndexRoute
  '/store/admin/collections/': typeof workspaceStoreAdminCollectionsIndexRoute
  '/store/admin/orders/': typeof workspaceStoreAdminOrdersIndexRoute
  '/store/admin/packs/': typeof workspaceStoreAdminPacksIndexRoute
  '/store/admin/pages/': typeof workspaceStoreAdminPagesIndexRoute
  '/store/admin/products/': typeof workspaceStoreAdminProductsIndexRoute
  '/store/admin/quotes/': typeof workspaceStoreAdminQuotesIndexRoute
  '/store/admin/reports/': typeof workspaceStoreAdminReportsIndexRoute
  '/store/admin/returns/': typeof workspaceStoreAdminReturnsIndexRoute
  '/store/admin/sampling/': typeof workspaceStoreAdminSamplingIndexRoute
  '/store/admin/storefront/': typeof workspaceStoreAdminStorefrontIndexRoute
  '/merchandising/styles/$styleId/design/pack': typeof workspaceMerchandisingStylesStyleIdDesignPackRoute
  '/store/admin/collections/$collectionId/edit': typeof workspaceStoreAdminCollectionsCollectionIdEditRoute
  '/store/admin/products/$listingId/edit': typeof workspaceStoreAdminProductsListingIdEditRoute
  '/merchandising/styles/$styleId/design/': typeof workspaceMerchandisingStylesStyleIdDesignIndexRoute
  '/store/admin/buyers/$buyerId/': typeof workspaceStoreAdminBuyersBuyerIdIndexRoute
  '/store/admin/collections/$collectionId/': typeof workspaceStoreAdminCollectionsCollectionIdIndexRoute
  '/store/admin/orders/$orderId/': typeof workspaceStoreAdminOrdersOrderIdIndexRoute
  '/store/admin/products/$listingId/': typeof workspaceStoreAdminProductsListingIdIndexRoute
  '/store/admin/quotes/$quoteId/': typeof workspaceStoreAdminQuotesQuoteIdIndexRoute
  '/store/admin/sampling/$sampleId/': typeof workspaceStoreAdminSamplingSampleIdIndexRoute
  '/store/admin/storefront/$appearanceId/': typeof workspaceStoreAdminStorefrontAppearanceIdIndexRoute
  '/store/admin/storefront/$appearanceId/preview/': typeof workspaceStoreAdminStorefrontAppearanceIdPreviewIndexRoute
  '/store/admin/storefront/templates/$templateKey/': typeof workspaceStoreAdminStorefrontTemplatesTemplateKeyIndexRoute
}
export interface FileRoutesByTo {
  '/launch': typeof LaunchRoute
  '/pos': typeof PosRoute
  '/subscription-ended': typeof SubscriptionEndedRoute
  '/': typeof workspaceIndexRoute
  '/station': typeof StationIndexRoute
  '/cash/movements': typeof workspaceCashMovementsRouteRouteWithChildren
  '/join/$token': typeof authJoinTokenRoute
  '/onboarding/account': typeof authOnboardingAccountRoute
  '/onboarding/done': typeof authOnboardingDoneRoute
  '/onboarding/tally': typeof authOnboardingTallyRoute
  '/onboarding/workspace': typeof authOnboardingWorkspaceRoute
  '/sign-in/otp': typeof authSignInOtpRoute
  '/approvals/$approvalId': typeof workspaceApprovalsApprovalIdRoute
  '/ask/$chatId': typeof workspaceAskChatIdRoute
  '/reports/$reportKey': typeof workspaceReportsReportKeyRoute
  '/reports/new': typeof workspaceReportsNewRoute
  '/sign-in': typeof authSignInIndexRoute
  '/approvals': typeof workspaceApprovalsIndexRoute
  '/ask': typeof workspaceAskIndexRoute
  '/documents': typeof workspaceDocumentsIndexRoute
  '/payroll': typeof workspacePayrollIndexRoute
  '/profile': typeof workspaceProfileIndexRoute
  '/reports': typeof workspaceReportsIndexRoute
  '/settings': typeof workspaceSettingsIndexRoute
  '/cash/bank-accounts/new': typeof workspaceCashBankAccountsNewRoute
  '/cash/movements/new': typeof workspaceCashMovementsNewRoute
  '/cash/petty-cash/$voucherId': typeof workspaceCashPettyCashVoucherIdRoute
  '/cash/petty-cash/count': typeof workspaceCashPettyCashCountRoute
  '/cash/petty-cash/counts': typeof workspaceCashPettyCashCountsRoute
  '/cash/petty-cash/new': typeof workspaceCashPettyCashNewRoute
  '/cash/petty-cash/replenish': typeof workspaceCashPettyCashReplenishRoute
  '/cash/transfers/$movementId': typeof workspaceCashTransfersMovementIdRoute
  '/cash/transfers/new': typeof workspaceCashTransfersNewRoute
  '/inventory/stock-adjustments/new': typeof workspaceInventoryStockAdjustmentsNewRoute
  '/inventory/stock-transfers/new': typeof workspaceInventoryStockTransfersNewRoute
  '/inventory/stock/opening': typeof workspaceInventoryStockOpeningRoute
  '/inventory/warehouses/new': typeof workspaceInventoryWarehousesNewRoute
  '/merchandising/orders/new': typeof workspaceMerchandisingOrdersNewRoute
  '/merchandising/styles/new': typeof workspaceMerchandisingStylesNewRoute
  '/payroll/employees/new': typeof workspacePayrollEmployeesNewRoute
  '/procurement/bills/new': typeof workspaceProcurementBillsNewRoute
  '/procurement/goods-receipts/new': typeof workspaceProcurementGoodsReceiptsNewRoute
  '/procurement/purchase-orders/new': typeof workspaceProcurementPurchaseOrdersNewRoute
  '/procurement/vendors/new': typeof workspaceProcurementVendorsNewRoute
  '/production/floor/$stage': typeof workspaceProductionFloorStageRoute
  '/production/floor/inward': typeof workspaceProductionFloorInwardRoute
  '/sales/customers/new': typeof workspaceSalesCustomersNewRoute
  '/sales/invoices/new': typeof workspaceSalesInvoicesNewRoute
  '/sales/items/new': typeof workspaceSalesItemsNewRoute
  '/sales/proformas/new': typeof workspaceSalesProformasNewRoute
  '/sales/receipts/$receiptId': typeof workspaceSalesReceiptsReceiptIdRoute
  '/cash/bank-accounts': typeof workspaceCashBankAccountsIndexRoute
  '/cash/petty-cash': typeof workspaceCashPettyCashIndexRoute
  '/cash/reconcile': typeof workspaceCashReconcileIndexRoute
  '/cash/transfers': typeof workspaceCashTransfersIndexRoute
  '/compliance/books': typeof workspaceComplianceBooksIndexRoute
  '/compliance/gst-returns': typeof workspaceComplianceGstReturnsIndexRoute
  '/compliance/itc04': typeof workspaceComplianceItc04IndexRoute
  '/compliance/tds': typeof workspaceComplianceTdsIndexRoute
  '/inventory/stock-adjustments': typeof workspaceInventoryStockAdjustmentsIndexRoute
  '/inventory/stock-transfers': typeof workspaceInventoryStockTransfersIndexRoute
  '/inventory/stock': typeof workspaceInventoryStockIndexRoute
  '/inventory/warehouses': typeof workspaceInventoryWarehousesIndexRoute
  '/merchandising/orders': typeof workspaceMerchandisingOrdersIndexRoute
  '/merchandising/risks': typeof workspaceMerchandisingRisksIndexRoute
  '/merchandising/styles': typeof workspaceMerchandisingStylesIndexRoute
  '/payroll/$runId': typeof workspacePayrollRunIdIndexRoute
  '/payroll/employees': typeof workspacePayrollEmployeesIndexRoute
  '/pos/shifts': typeof workspacePosShiftsIndexRoute
  '/procurement/bills': typeof workspaceProcurementBillsIndexRoute
  '/procurement/goods-receipts': typeof workspaceProcurementGoodsReceiptsIndexRoute
  '/procurement/payments': typeof workspaceProcurementPaymentsIndexRoute
  '/procurement/purchase-orders': typeof workspaceProcurementPurchaseOrdersIndexRoute
  '/procurement/vendors': typeof workspaceProcurementVendorsIndexRoute
  '/production/floor': typeof workspaceProductionFloorIndexRoute
  '/records/audit-log': typeof workspaceRecordsAuditLogIndexRoute
  '/sales/collections': typeof workspaceSalesCollectionsIndexRoute
  '/sales/customers': typeof workspaceSalesCustomersIndexRoute
  '/sales/invoices': typeof workspaceSalesInvoicesIndexRoute
  '/sales/items': typeof workspaceSalesItemsIndexRoute
  '/sales/proformas': typeof workspaceSalesProformasIndexRoute
  '/sales/receipts': typeof workspaceSalesReceiptsIndexRoute
  '/settings/about': typeof workspaceSettingsAboutIndexRoute
  '/settings/approvals': typeof workspaceSettingsApprovalsIndexRoute
  '/settings/assistant': typeof workspaceSettingsAssistantIndexRoute
  '/settings/billing': typeof workspaceSettingsBillingIndexRoute
  '/settings/company': typeof workspaceSettingsCompanyIndexRoute
  '/settings/gstin': typeof workspaceSettingsGstinIndexRoute
  '/settings/integrations': typeof workspaceSettingsIntegrationsIndexRoute
  '/settings/notifications': typeof workspaceSettingsNotificationsIndexRoute
  '/settings/numbering': typeof workspaceSettingsNumberingIndexRoute
  '/settings/profile': typeof workspaceSettingsProfileIndexRoute
  '/settings/recurring': typeof workspaceSettingsRecurringIndexRoute
  '/settings/roles': typeof workspaceSettingsRolesIndexRoute
  '/settings/subscription': typeof workspaceSettingsSubscriptionIndexRoute
  '/settings/team': typeof workspaceSettingsTeamIndexRoute
  '/settings/templates': typeof workspaceSettingsTemplatesIndexRoute
  '/store/admin': typeof workspaceStoreAdminIndexRoute
  '/cash/bank-accounts/$bankAccountId/edit': typeof workspaceCashBankAccountsBankAccountIdEditRoute
  '/inventory/warehouses/$warehouseId/edit': typeof workspaceInventoryWarehousesWarehouseIdEditRoute
  '/merchandising/orders/$orderId/edit': typeof workspaceMerchandisingOrdersOrderIdEditRoute
  '/merchandising/styles/$styleId/costing': typeof workspaceMerchandisingStylesStyleIdCostingRoute
  '/merchandising/styles/$styleId/dispatch': typeof workspaceMerchandisingStylesStyleIdDispatchRoute
  '/merchandising/styles/$styleId/materials': typeof workspaceMerchandisingStylesStyleIdMaterialsRoute
  '/merchandising/styles/$styleId/overview': typeof workspaceMerchandisingStylesStyleIdOverviewRoute
  '/merchandising/styles/$styleId/timeline': typeof workspaceMerchandisingStylesStyleIdTimelineRoute
  '/merchandising/styles/$styleId/visual': typeof workspaceMerchandisingStylesStyleIdVisualRoute
  '/payroll/employees/$employeeId/edit': typeof workspacePayrollEmployeesEmployeeIdEditRoute
  '/procurement/bills/$billId/edit': typeof workspaceProcurementBillsBillIdEditRoute
  '/procurement/goods-receipts/$grnId/edit': typeof workspaceProcurementGoodsReceiptsGrnIdEditRoute
  '/procurement/purchase-orders/$poId/edit': typeof workspaceProcurementPurchaseOrdersPoIdEditRoute
  '/procurement/vendors/$vendorId/edit': typeof workspaceProcurementVendorsVendorIdEditRoute
  '/production/styles/$styleId/production': typeof workspaceProductionStylesStyleIdProductionRoute
  '/quality/styles/$styleId/qc': typeof workspaceQualityStylesStyleIdQcRoute
  '/sales/customers/$customerId/edit': typeof workspaceSalesCustomersCustomerIdEditRoute
  '/sales/customers/$customerId/ledger': typeof workspaceSalesCustomersCustomerIdLedgerRoute
  '/sales/invoices/$invoiceId/edit': typeof workspaceSalesInvoicesInvoiceIdEditRoute
  '/sales/items/$itemId/edit': typeof workspaceSalesItemsItemIdEditRoute
  '/sales/proformas/$proformaId/edit': typeof workspaceSalesProformasProformaIdEditRoute
  '/sampling/styles/$styleId/samples': typeof workspaceSamplingStylesStyleIdSamplesRoute
  '/store/admin/collections/new': typeof workspaceStoreAdminCollectionsNewRoute
  '/store/admin/products/new': typeof workspaceStoreAdminProductsNewRoute
  '/store/admin/quotes/new': typeof workspaceStoreAdminQuotesNewRoute
  '/cash/bank-accounts/$bankAccountId': typeof workspaceCashBankAccountsBankAccountIdIndexRoute
  '/inventory/warehouses/$warehouseId': typeof workspaceInventoryWarehousesWarehouseIdIndexRoute
  '/merchandising/orders/$orderId': typeof workspaceMerchandisingOrdersOrderIdIndexRoute
  '/merchandising/styles/$styleId': typeof workspaceMerchandisingStylesStyleIdIndexRoute
  '/payroll/employees/$employeeId': typeof workspacePayrollEmployeesEmployeeIdIndexRoute
  '/procurement/bills/$billId': typeof workspaceProcurementBillsBillIdIndexRoute
  '/procurement/goods-receipts/$grnId': typeof workspaceProcurementGoodsReceiptsGrnIdIndexRoute
  '/procurement/purchase-orders/$poId': typeof workspaceProcurementPurchaseOrdersPoIdIndexRoute
  '/procurement/vendors/$vendorId': typeof workspaceProcurementVendorsVendorIdIndexRoute
  '/sales/customers/$customerId': typeof workspaceSalesCustomersCustomerIdIndexRoute
  '/sales/invoices/$invoiceId': typeof workspaceSalesInvoicesInvoiceIdIndexRoute
  '/sales/items/$itemId': typeof workspaceSalesItemsItemIdIndexRoute
  '/sales/proformas/$proformaId': typeof workspaceSalesProformasProformaIdIndexRoute
  '/store/admin/buyers': typeof workspaceStoreAdminBuyersIndexRoute
  '/store/admin/collections': typeof workspaceStoreAdminCollectionsIndexRoute
  '/store/admin/orders': typeof workspaceStoreAdminOrdersIndexRoute
  '/store/admin/packs': typeof workspaceStoreAdminPacksIndexRoute
  '/store/admin/pages': typeof workspaceStoreAdminPagesIndexRoute
  '/store/admin/products': typeof workspaceStoreAdminProductsIndexRoute
  '/store/admin/quotes': typeof workspaceStoreAdminQuotesIndexRoute
  '/store/admin/reports': typeof workspaceStoreAdminReportsIndexRoute
  '/store/admin/returns': typeof workspaceStoreAdminReturnsIndexRoute
  '/store/admin/sampling': typeof workspaceStoreAdminSamplingIndexRoute
  '/store/admin/storefront': typeof workspaceStoreAdminStorefrontIndexRoute
  '/merchandising/styles/$styleId/design/pack': typeof workspaceMerchandisingStylesStyleIdDesignPackRoute
  '/store/admin/collections/$collectionId/edit': typeof workspaceStoreAdminCollectionsCollectionIdEditRoute
  '/store/admin/products/$listingId/edit': typeof workspaceStoreAdminProductsListingIdEditRoute
  '/merchandising/styles/$styleId/design': typeof workspaceMerchandisingStylesStyleIdDesignIndexRoute
  '/store/admin/buyers/$buyerId': typeof workspaceStoreAdminBuyersBuyerIdIndexRoute
  '/store/admin/collections/$collectionId': typeof workspaceStoreAdminCollectionsCollectionIdIndexRoute
  '/store/admin/orders/$orderId': typeof workspaceStoreAdminOrdersOrderIdIndexRoute
  '/store/admin/products/$listingId': typeof workspaceStoreAdminProductsListingIdIndexRoute
  '/store/admin/quotes/$quoteId': typeof workspaceStoreAdminQuotesQuoteIdIndexRoute
  '/store/admin/sampling/$sampleId': typeof workspaceStoreAdminSamplingSampleIdIndexRoute
  '/store/admin/storefront/$appearanceId': typeof workspaceStoreAdminStorefrontAppearanceIdIndexRoute
  '/store/admin/storefront/$appearanceId/preview': typeof workspaceStoreAdminStorefrontAppearanceIdPreviewIndexRoute
  '/store/admin/storefront/templates/$templateKey': typeof workspaceStoreAdminStorefrontTemplatesTemplateKeyIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(workspace)': typeof workspaceRouteRouteWithChildren
  '/launch': typeof LaunchRoute
  '/pos': typeof PosRoute
  '/subscription-ended': typeof SubscriptionEndedRoute
  '/(workspace)/documents': typeof workspaceDocumentsRouteRouteWithChildren
  '/(workspace)/payroll': typeof workspacePayrollRouteRouteWithChildren
  '/(workspace)/reports': typeof workspaceReportsRouteRouteWithChildren
  '/(workspace)/approvals': typeof workspaceApprovalsRouteWithChildren
  '/(workspace)/': typeof workspaceIndexRoute
  '/station/': typeof StationIndexRoute
  '/(workspace)/cash/movements': typeof workspaceCashMovementsRouteRouteWithChildren
  '/(workspace)/cash/petty-cash': typeof workspaceCashPettyCashRouteRouteWithChildren
  '/(workspace)/cash/reconcile': typeof workspaceCashReconcileRouteRouteWithChildren
  '/(workspace)/cash/transfers': typeof workspaceCashTransfersRouteRouteWithChildren
  '/(workspace)/compliance/books': typeof workspaceComplianceBooksRouteRouteWithChildren
  '/(workspace)/inventory/stock-transfers': typeof workspaceInventoryStockTransfersRouteRouteWithChildren
  '/(auth)/join/$token': typeof authJoinTokenRoute
  '/(auth)/onboarding/account': typeof authOnboardingAccountRoute
  '/(auth)/onboarding/done': typeof authOnboardingDoneRoute
  '/(auth)/onboarding/tally': typeof authOnboardingTallyRoute
  '/(auth)/onboarding/workspace': typeof authOnboardingWorkspaceRoute
  '/(auth)/sign-in/otp': typeof authSignInOtpRoute
  '/(workspace)/approvals/$approvalId': typeof workspaceApprovalsApprovalIdRoute
  '/(workspace)/ask/$chatId': typeof workspaceAskChatIdRoute
  '/(workspace)/reports/$reportKey': typeof workspaceReportsReportKeyRoute
  '/(workspace)/reports/new': typeof workspaceReportsNewRoute
  '/(auth)/sign-in/': typeof authSignInIndexRoute
  '/(workspace)/approvals/': typeof workspaceApprovalsIndexRoute
  '/(workspace)/ask/': typeof workspaceAskIndexRoute
  '/(workspace)/documents/': typeof workspaceDocumentsIndexRoute
  '/(workspace)/payroll/': typeof workspacePayrollIndexRoute
  '/(workspace)/profile/': typeof workspaceProfileIndexRoute
  '/(workspace)/reports/': typeof workspaceReportsIndexRoute
  '/(workspace)/settings/': typeof workspaceSettingsIndexRoute
  '/(workspace)/cash/bank-accounts/new': typeof workspaceCashBankAccountsNewRoute
  '/(workspace)/cash/movements/new': typeof workspaceCashMovementsNewRoute
  '/(workspace)/cash/petty-cash/$voucherId': typeof workspaceCashPettyCashVoucherIdRoute
  '/(workspace)/cash/petty-cash/count': typeof workspaceCashPettyCashCountRoute
  '/(workspace)/cash/petty-cash/counts': typeof workspaceCashPettyCashCountsRoute
  '/(workspace)/cash/petty-cash/new': typeof workspaceCashPettyCashNewRoute
  '/(workspace)/cash/petty-cash/replenish': typeof workspaceCashPettyCashReplenishRoute
  '/(workspace)/cash/transfers/$movementId': typeof workspaceCashTransfersMovementIdRoute
  '/(workspace)/cash/transfers/new': typeof workspaceCashTransfersNewRoute
  '/(workspace)/inventory/stock-adjustments/new': typeof workspaceInventoryStockAdjustmentsNewRoute
  '/(workspace)/inventory/stock-transfers/new': typeof workspaceInventoryStockTransfersNewRoute
  '/(workspace)/inventory/stock/opening': typeof workspaceInventoryStockOpeningRoute
  '/(workspace)/inventory/warehouses/new': typeof workspaceInventoryWarehousesNewRoute
  '/(workspace)/merchandising/orders/new': typeof workspaceMerchandisingOrdersNewRoute
  '/(workspace)/merchandising/styles/new': typeof workspaceMerchandisingStylesNewRoute
  '/(workspace)/payroll/employees/new': typeof workspacePayrollEmployeesNewRoute
  '/(workspace)/procurement/bills/new': typeof workspaceProcurementBillsNewRoute
  '/(workspace)/procurement/goods-receipts/new': typeof workspaceProcurementGoodsReceiptsNewRoute
  '/(workspace)/procurement/purchase-orders/new': typeof workspaceProcurementPurchaseOrdersNewRoute
  '/(workspace)/procurement/vendors/new': typeof workspaceProcurementVendorsNewRoute
  '/(workspace)/production/floor/$stage': typeof workspaceProductionFloorStageRoute
  '/(workspace)/production/floor/inward': typeof workspaceProductionFloorInwardRoute
  '/(workspace)/sales/customers/new': typeof workspaceSalesCustomersNewRoute
  '/(workspace)/sales/invoices/new': typeof workspaceSalesInvoicesNewRoute
  '/(workspace)/sales/items/new': typeof workspaceSalesItemsNewRoute
  '/(workspace)/sales/proformas/new': typeof workspaceSalesProformasNewRoute
  '/(workspace)/sales/receipts/$receiptId': typeof workspaceSalesReceiptsReceiptIdRoute
  '/(workspace)/cash/bank-accounts/': typeof workspaceCashBankAccountsIndexRoute
  '/(workspace)/cash/petty-cash/': typeof workspaceCashPettyCashIndexRoute
  '/(workspace)/cash/reconcile/': typeof workspaceCashReconcileIndexRoute
  '/(workspace)/cash/transfers/': typeof workspaceCashTransfersIndexRoute
  '/(workspace)/compliance/books/': typeof workspaceComplianceBooksIndexRoute
  '/(workspace)/compliance/gst-returns/': typeof workspaceComplianceGstReturnsIndexRoute
  '/(workspace)/compliance/itc04/': typeof workspaceComplianceItc04IndexRoute
  '/(workspace)/compliance/tds/': typeof workspaceComplianceTdsIndexRoute
  '/(workspace)/inventory/stock-adjustments/': typeof workspaceInventoryStockAdjustmentsIndexRoute
  '/(workspace)/inventory/stock-transfers/': typeof workspaceInventoryStockTransfersIndexRoute
  '/(workspace)/inventory/stock/': typeof workspaceInventoryStockIndexRoute
  '/(workspace)/inventory/warehouses/': typeof workspaceInventoryWarehousesIndexRoute
  '/(workspace)/merchandising/orders/': typeof workspaceMerchandisingOrdersIndexRoute
  '/(workspace)/merchandising/risks/': typeof workspaceMerchandisingRisksIndexRoute
  '/(workspace)/merchandising/styles/': typeof workspaceMerchandisingStylesIndexRoute
  '/(workspace)/payroll/$runId/': typeof workspacePayrollRunIdIndexRoute
  '/(workspace)/payroll/employees/': typeof workspacePayrollEmployeesIndexRoute
  '/(workspace)/pos/shifts/': typeof workspacePosShiftsIndexRoute
  '/(workspace)/procurement/bills/': typeof workspaceProcurementBillsIndexRoute
  '/(workspace)/procurement/goods-receipts/': typeof workspaceProcurementGoodsReceiptsIndexRoute
  '/(workspace)/procurement/payments/': typeof workspaceProcurementPaymentsIndexRoute
  '/(workspace)/procurement/purchase-orders/': typeof workspaceProcurementPurchaseOrdersIndexRoute
  '/(workspace)/procurement/vendors/': typeof workspaceProcurementVendorsIndexRoute
  '/(workspace)/production/floor/': typeof workspaceProductionFloorIndexRoute
  '/(workspace)/records/audit-log/': typeof workspaceRecordsAuditLogIndexRoute
  '/(workspace)/sales/collections/': typeof workspaceSalesCollectionsIndexRoute
  '/(workspace)/sales/customers/': typeof workspaceSalesCustomersIndexRoute
  '/(workspace)/sales/invoices/': typeof workspaceSalesInvoicesIndexRoute
  '/(workspace)/sales/items/': typeof workspaceSalesItemsIndexRoute
  '/(workspace)/sales/proformas/': typeof workspaceSalesProformasIndexRoute
  '/(workspace)/sales/receipts/': typeof workspaceSalesReceiptsIndexRoute
  '/(workspace)/settings/about/': typeof workspaceSettingsAboutIndexRoute
  '/(workspace)/settings/approvals/': typeof workspaceSettingsApprovalsIndexRoute
  '/(workspace)/settings/assistant/': typeof workspaceSettingsAssistantIndexRoute
  '/(workspace)/settings/billing/': typeof workspaceSettingsBillingIndexRoute
  '/(workspace)/settings/company/': typeof workspaceSettingsCompanyIndexRoute
  '/(workspace)/settings/gstin/': typeof workspaceSettingsGstinIndexRoute
  '/(workspace)/settings/integrations/': typeof workspaceSettingsIntegrationsIndexRoute
  '/(workspace)/settings/notifications/': typeof workspaceSettingsNotificationsIndexRoute
  '/(workspace)/settings/numbering/': typeof workspaceSettingsNumberingIndexRoute
  '/(workspace)/settings/profile/': typeof workspaceSettingsProfileIndexRoute
  '/(workspace)/settings/recurring/': typeof workspaceSettingsRecurringIndexRoute
  '/(workspace)/settings/roles/': typeof workspaceSettingsRolesIndexRoute
  '/(workspace)/settings/subscription/': typeof workspaceSettingsSubscriptionIndexRoute
  '/(workspace)/settings/team/': typeof workspaceSettingsTeamIndexRoute
  '/(workspace)/settings/templates/': typeof workspaceSettingsTemplatesIndexRoute
  '/(workspace)/store/admin/': typeof workspaceStoreAdminIndexRoute
  '/(workspace)/cash/bank-accounts/$bankAccountId/edit': typeof workspaceCashBankAccountsBankAccountIdEditRoute
  '/(workspace)/inventory/warehouses/$warehouseId/edit': typeof workspaceInventoryWarehousesWarehouseIdEditRoute
  '/(workspace)/merchandising/orders/$orderId/edit': typeof workspaceMerchandisingOrdersOrderIdEditRoute
  '/(workspace)/merchandising/styles/$styleId/costing': typeof workspaceMerchandisingStylesStyleIdCostingRoute
  '/(workspace)/merchandising/styles/$styleId/dispatch': typeof workspaceMerchandisingStylesStyleIdDispatchRoute
  '/(workspace)/merchandising/styles/$styleId/materials': typeof workspaceMerchandisingStylesStyleIdMaterialsRoute
  '/(workspace)/merchandising/styles/$styleId/overview': typeof workspaceMerchandisingStylesStyleIdOverviewRoute
  '/(workspace)/merchandising/styles/$styleId/timeline': typeof workspaceMerchandisingStylesStyleIdTimelineRoute
  '/(workspace)/merchandising/styles/$styleId/visual': typeof workspaceMerchandisingStylesStyleIdVisualRoute
  '/(workspace)/payroll/employees/$employeeId/edit': typeof workspacePayrollEmployeesEmployeeIdEditRoute
  '/(workspace)/procurement/bills/$billId/edit': typeof workspaceProcurementBillsBillIdEditRoute
  '/(workspace)/procurement/goods-receipts/$grnId/edit': typeof workspaceProcurementGoodsReceiptsGrnIdEditRoute
  '/(workspace)/procurement/purchase-orders/$poId/edit': typeof workspaceProcurementPurchaseOrdersPoIdEditRoute
  '/(workspace)/procurement/vendors/$vendorId/edit': typeof workspaceProcurementVendorsVendorIdEditRoute
  '/(workspace)/production/styles/$styleId/production': typeof workspaceProductionStylesStyleIdProductionRoute
  '/(workspace)/quality/styles/$styleId/qc': typeof workspaceQualityStylesStyleIdQcRoute
  '/(workspace)/sales/customers/$customerId/edit': typeof workspaceSalesCustomersCustomerIdEditRoute
  '/(workspace)/sales/customers/$customerId/ledger': typeof workspaceSalesCustomersCustomerIdLedgerRoute
  '/(workspace)/sales/invoices_/$invoiceId/edit': typeof workspaceSalesInvoicesInvoiceIdEditRoute
  '/(workspace)/sales/items/$itemId/edit': typeof workspaceSalesItemsItemIdEditRoute
  '/(workspace)/sales/proformas_/$proformaId/edit': typeof workspaceSalesProformasProformaIdEditRoute
  '/(workspace)/sampling/styles/$styleId/samples': typeof workspaceSamplingStylesStyleIdSamplesRoute
  '/(workspace)/store/admin/collections/new': typeof workspaceStoreAdminCollectionsNewRoute
  '/(workspace)/store/admin/products/new': typeof workspaceStoreAdminProductsNewRoute
  '/(workspace)/store/admin/quotes/new': typeof workspaceStoreAdminQuotesNewRoute
  '/(workspace)/cash/bank-accounts/$bankAccountId/': typeof workspaceCashBankAccountsBankAccountIdIndexRoute
  '/(workspace)/inventory/warehouses/$warehouseId/': typeof workspaceInventoryWarehousesWarehouseIdIndexRoute
  '/(workspace)/merchandising/orders/$orderId/': typeof workspaceMerchandisingOrdersOrderIdIndexRoute
  '/(workspace)/merchandising/styles/$styleId/': typeof workspaceMerchandisingStylesStyleIdIndexRoute
  '/(workspace)/payroll/employees/$employeeId/': typeof workspacePayrollEmployeesEmployeeIdIndexRoute
  '/(workspace)/procurement/bills/$billId/': typeof workspaceProcurementBillsBillIdIndexRoute
  '/(workspace)/procurement/goods-receipts/$grnId/': typeof workspaceProcurementGoodsReceiptsGrnIdIndexRoute
  '/(workspace)/procurement/purchase-orders/$poId/': typeof workspaceProcurementPurchaseOrdersPoIdIndexRoute
  '/(workspace)/procurement/vendors/$vendorId/': typeof workspaceProcurementVendorsVendorIdIndexRoute
  '/(workspace)/sales/customers/$customerId/': typeof workspaceSalesCustomersCustomerIdIndexRoute
  '/(workspace)/sales/invoices/$invoiceId/': typeof workspaceSalesInvoicesInvoiceIdIndexRoute
  '/(workspace)/sales/items/$itemId/': typeof workspaceSalesItemsItemIdIndexRoute
  '/(workspace)/sales/proformas/$proformaId/': typeof workspaceSalesProformasProformaIdIndexRoute
  '/(workspace)/store/admin/buyers/': typeof workspaceStoreAdminBuyersIndexRoute
  '/(workspace)/store/admin/collections/': typeof workspaceStoreAdminCollectionsIndexRoute
  '/(workspace)/store/admin/orders/': typeof workspaceStoreAdminOrdersIndexRoute
  '/(workspace)/store/admin/packs/': typeof workspaceStoreAdminPacksIndexRoute
  '/(workspace)/store/admin/pages/': typeof workspaceStoreAdminPagesIndexRoute
  '/(workspace)/store/admin/products/': typeof workspaceStoreAdminProductsIndexRoute
  '/(workspace)/store/admin/quotes/': typeof workspaceStoreAdminQuotesIndexRoute
  '/(workspace)/store/admin/reports/': typeof workspaceStoreAdminReportsIndexRoute
  '/(workspace)/store/admin/returns/': typeof workspaceStoreAdminReturnsIndexRoute
  '/(workspace)/store/admin/sampling/': typeof workspaceStoreAdminSamplingIndexRoute
  '/(workspace)/store/admin/storefront/': typeof workspaceStoreAdminStorefrontIndexRoute
  '/(workspace)/merchandising/styles/$styleId/design/pack': typeof workspaceMerchandisingStylesStyleIdDesignPackRoute
  '/(workspace)/store/admin/collections/$collectionId/edit': typeof workspaceStoreAdminCollectionsCollectionIdEditRoute
  '/(workspace)/store/admin/products/$listingId/edit': typeof workspaceStoreAdminProductsListingIdEditRoute
  '/(workspace)/merchandising/styles/$styleId/design/': typeof workspaceMerchandisingStylesStyleIdDesignIndexRoute
  '/(workspace)/store/admin/buyers/$buyerId/': typeof workspaceStoreAdminBuyersBuyerIdIndexRoute
  '/(workspace)/store/admin/collections/$collectionId/': typeof workspaceStoreAdminCollectionsCollectionIdIndexRoute
  '/(workspace)/store/admin/orders/$orderId/': typeof workspaceStoreAdminOrdersOrderIdIndexRoute
  '/(workspace)/store/admin/products/$listingId/': typeof workspaceStoreAdminProductsListingIdIndexRoute
  '/(workspace)/store/admin/quotes/$quoteId/': typeof workspaceStoreAdminQuotesQuoteIdIndexRoute
  '/(workspace)/store/admin/sampling/$sampleId/': typeof workspaceStoreAdminSamplingSampleIdIndexRoute
  '/(workspace)/store/admin/storefront/$appearanceId/': typeof workspaceStoreAdminStorefrontAppearanceIdIndexRoute
  '/(workspace)/store/admin/storefront/$appearanceId/preview/': typeof workspaceStoreAdminStorefrontAppearanceIdPreviewIndexRoute
  '/(workspace)/store/admin/storefront/templates/$templateKey/': typeof workspaceStoreAdminStorefrontTemplatesTemplateKeyIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/launch'
    | '/pos'
    | '/subscription-ended'
    | '/documents'
    | '/payroll'
    | '/reports'
    | '/approvals'
    | '/'
    | '/station/'
    | '/cash/movements'
    | '/cash/petty-cash'
    | '/cash/reconcile'
    | '/cash/transfers'
    | '/compliance/books'
    | '/inventory/stock-transfers'
    | '/join/$token'
    | '/onboarding/account'
    | '/onboarding/done'
    | '/onboarding/tally'
    | '/onboarding/workspace'
    | '/sign-in/otp'
    | '/approvals/$approvalId'
    | '/ask/$chatId'
    | '/reports/$reportKey'
    | '/reports/new'
    | '/sign-in/'
    | '/approvals/'
    | '/ask/'
    | '/documents/'
    | '/payroll/'
    | '/profile/'
    | '/reports/'
    | '/settings/'
    | '/cash/bank-accounts/new'
    | '/cash/movements/new'
    | '/cash/petty-cash/$voucherId'
    | '/cash/petty-cash/count'
    | '/cash/petty-cash/counts'
    | '/cash/petty-cash/new'
    | '/cash/petty-cash/replenish'
    | '/cash/transfers/$movementId'
    | '/cash/transfers/new'
    | '/inventory/stock-adjustments/new'
    | '/inventory/stock-transfers/new'
    | '/inventory/stock/opening'
    | '/inventory/warehouses/new'
    | '/merchandising/orders/new'
    | '/merchandising/styles/new'
    | '/payroll/employees/new'
    | '/procurement/bills/new'
    | '/procurement/goods-receipts/new'
    | '/procurement/purchase-orders/new'
    | '/procurement/vendors/new'
    | '/production/floor/$stage'
    | '/production/floor/inward'
    | '/sales/customers/new'
    | '/sales/invoices/new'
    | '/sales/items/new'
    | '/sales/proformas/new'
    | '/sales/receipts/$receiptId'
    | '/cash/bank-accounts/'
    | '/cash/petty-cash/'
    | '/cash/reconcile/'
    | '/cash/transfers/'
    | '/compliance/books/'
    | '/compliance/gst-returns/'
    | '/compliance/itc04/'
    | '/compliance/tds/'
    | '/inventory/stock-adjustments/'
    | '/inventory/stock-transfers/'
    | '/inventory/stock/'
    | '/inventory/warehouses/'
    | '/merchandising/orders/'
    | '/merchandising/risks/'
    | '/merchandising/styles/'
    | '/payroll/$runId/'
    | '/payroll/employees/'
    | '/pos/shifts/'
    | '/procurement/bills/'
    | '/procurement/goods-receipts/'
    | '/procurement/payments/'
    | '/procurement/purchase-orders/'
    | '/procurement/vendors/'
    | '/production/floor/'
    | '/records/audit-log/'
    | '/sales/collections/'
    | '/sales/customers/'
    | '/sales/invoices/'
    | '/sales/items/'
    | '/sales/proformas/'
    | '/sales/receipts/'
    | '/settings/about/'
    | '/settings/approvals/'
    | '/settings/assistant/'
    | '/settings/billing/'
    | '/settings/company/'
    | '/settings/gstin/'
    | '/settings/integrations/'
    | '/settings/notifications/'
    | '/settings/numbering/'
    | '/settings/profile/'
    | '/settings/recurring/'
    | '/settings/roles/'
    | '/settings/subscription/'
    | '/settings/team/'
    | '/settings/templates/'
    | '/store/admin/'
    | '/cash/bank-accounts/$bankAccountId/edit'
    | '/inventory/warehouses/$warehouseId/edit'
    | '/merchandising/orders/$orderId/edit'
    | '/merchandising/styles/$styleId/costing'
    | '/merchandising/styles/$styleId/dispatch'
    | '/merchandising/styles/$styleId/materials'
    | '/merchandising/styles/$styleId/overview'
    | '/merchandising/styles/$styleId/timeline'
    | '/merchandising/styles/$styleId/visual'
    | '/payroll/employees/$employeeId/edit'
    | '/procurement/bills/$billId/edit'
    | '/procurement/goods-receipts/$grnId/edit'
    | '/procurement/purchase-orders/$poId/edit'
    | '/procurement/vendors/$vendorId/edit'
    | '/production/styles/$styleId/production'
    | '/quality/styles/$styleId/qc'
    | '/sales/customers/$customerId/edit'
    | '/sales/customers/$customerId/ledger'
    | '/sales/invoices/$invoiceId/edit'
    | '/sales/items/$itemId/edit'
    | '/sales/proformas/$proformaId/edit'
    | '/sampling/styles/$styleId/samples'
    | '/store/admin/collections/new'
    | '/store/admin/products/new'
    | '/store/admin/quotes/new'
    | '/cash/bank-accounts/$bankAccountId/'
    | '/inventory/warehouses/$warehouseId/'
    | '/merchandising/orders/$orderId/'
    | '/merchandising/styles/$styleId/'
    | '/payroll/employees/$employeeId/'
    | '/procurement/bills/$billId/'
    | '/procurement/goods-receipts/$grnId/'
    | '/procurement/purchase-orders/$poId/'
    | '/procurement/vendors/$vendorId/'
    | '/sales/customers/$customerId/'
    | '/sales/invoices/$invoiceId/'
    | '/sales/items/$itemId/'
    | '/sales/proformas/$proformaId/'
    | '/store/admin/buyers/'
    | '/store/admin/collections/'
    | '/store/admin/orders/'
    | '/store/admin/packs/'
    | '/store/admin/pages/'
    | '/store/admin/products/'
    | '/store/admin/quotes/'
    | '/store/admin/reports/'
    | '/store/admin/returns/'
    | '/store/admin/sampling/'
    | '/store/admin/storefront/'
    | '/merchandising/styles/$styleId/design/pack'
    | '/store/admin/collections/$collectionId/edit'
    | '/store/admin/products/$listingId/edit'
    | '/merchandising/styles/$styleId/design/'
    | '/store/admin/buyers/$buyerId/'
    | '/store/admin/collections/$collectionId/'
    | '/store/admin/orders/$orderId/'
    | '/store/admin/products/$listingId/'
    | '/store/admin/quotes/$quoteId/'
    | '/store/admin/sampling/$sampleId/'
    | '/store/admin/storefront/$appearanceId/'
    | '/store/admin/storefront/$appearanceId/preview/'
    | '/store/admin/storefront/templates/$templateKey/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/launch'
    | '/pos'
    | '/subscription-ended'
    | '/'
    | '/station'
    | '/cash/movements'
    | '/join/$token'
    | '/onboarding/account'
    | '/onboarding/done'
    | '/onboarding/tally'
    | '/onboarding/workspace'
    | '/sign-in/otp'
    | '/approvals/$approvalId'
    | '/ask/$chatId'
    | '/reports/$reportKey'
    | '/reports/new'
    | '/sign-in'
    | '/approvals'
    | '/ask'
    | '/documents'
    | '/payroll'
    | '/profile'
    | '/reports'
    | '/settings'
    | '/cash/bank-accounts/new'
    | '/cash/movements/new'
    | '/cash/petty-cash/$voucherId'
    | '/cash/petty-cash/count'
    | '/cash/petty-cash/counts'
    | '/cash/petty-cash/new'
    | '/cash/petty-cash/replenish'
    | '/cash/transfers/$movementId'
    | '/cash/transfers/new'
    | '/inventory/stock-adjustments/new'
    | '/inventory/stock-transfers/new'
    | '/inventory/stock/opening'
    | '/inventory/warehouses/new'
    | '/merchandising/orders/new'
    | '/merchandising/styles/new'
    | '/payroll/employees/new'
    | '/procurement/bills/new'
    | '/procurement/goods-receipts/new'
    | '/procurement/purchase-orders/new'
    | '/procurement/vendors/new'
    | '/production/floor/$stage'
    | '/production/floor/inward'
    | '/sales/customers/new'
    | '/sales/invoices/new'
    | '/sales/items/new'
    | '/sales/proformas/new'
    | '/sales/receipts/$receiptId'
    | '/cash/bank-accounts'
    | '/cash/petty-cash'
    | '/cash/reconcile'
    | '/cash/transfers'
    | '/compliance/books'
    | '/compliance/gst-returns'
    | '/compliance/itc04'
    | '/compliance/tds'
    | '/inventory/stock-adjustments'
    | '/inventory/stock-transfers'
    | '/inventory/stock'
    | '/inventory/warehouses'
    | '/merchandising/orders'
    | '/merchandising/risks'
    | '/merchandising/styles'
    | '/payroll/$runId'
    | '/payroll/employees'
    | '/pos/shifts'
    | '/procurement/bills'
    | '/procurement/goods-receipts'
    | '/procurement/payments'
    | '/procurement/purchase-orders'
    | '/procurement/vendors'
    | '/production/floor'
    | '/records/audit-log'
    | '/sales/collections'
    | '/sales/customers'
    | '/sales/invoices'
    | '/sales/items'
    | '/sales/proformas'
    | '/sales/receipts'
    | '/settings/about'
    | '/settings/approvals'
    | '/settings/assistant'
    | '/settings/billing'
    | '/settings/company'
    | '/settings/gstin'
    | '/settings/integrations'
    | '/settings/notifications'
    | '/settings/numbering'
    | '/settings/profile'
    | '/settings/recurring'
    | '/settings/roles'
    | '/settings/subscription'
    | '/settings/team'
    | '/settings/templates'
    | '/store/admin'
    | '/cash/bank-accounts/$bankAccountId/edit'
    | '/inventory/warehouses/$warehouseId/edit'
    | '/merchandising/orders/$orderId/edit'
    | '/merchandising/styles/$styleId/costing'
    | '/merchandising/styles/$styleId/dispatch'
    | '/merchandising/styles/$styleId/materials'
    | '/merchandising/styles/$styleId/overview'
    | '/merchandising/styles/$styleId/timeline'
    | '/merchandising/styles/$styleId/visual'
    | '/payroll/employees/$employeeId/edit'
    | '/procurement/bills/$billId/edit'
    | '/procurement/goods-receipts/$grnId/edit'
    | '/procurement/purchase-orders/$poId/edit'
    | '/procurement/vendors/$vendorId/edit'
    | '/production/styles/$styleId/production'
    | '/quality/styles/$styleId/qc'
    | '/sales/customers/$customerId/edit'
    | '/sales/customers/$customerId/ledger'
    | '/sales/invoices/$invoiceId/edit'
    | '/sales/items/$itemId/edit'
    | '/sales/proformas/$proformaId/edit'
    | '/sampling/styles/$styleId/samples'
    | '/store/admin/collections/new'
    | '/store/admin/products/new'
    | '/store/admin/quotes/new'
    | '/cash/bank-accounts/$bankAccountId'
    | '/inventory/warehouses/$warehouseId'
    | '/merchandising/orders/$orderId'
    | '/merchandising/styles/$styleId'
    | '/payroll/employees/$employeeId'
    | '/procurement/bills/$billId'
    | '/procurement/goods-receipts/$grnId'
    | '/procurement/purchase-orders/$poId'
    | '/procurement/vendors/$vendorId'
    | '/sales/customers/$customerId'
    | '/sales/invoices/$invoiceId'
    | '/sales/items/$itemId'
    | '/sales/proformas/$proformaId'
    | '/store/admin/buyers'
    | '/store/admin/collections'
    | '/store/admin/orders'
    | '/store/admin/packs'
    | '/store/admin/pages'
    | '/store/admin/products'
    | '/store/admin/quotes'
    | '/store/admin/reports'
    | '/store/admin/returns'
    | '/store/admin/sampling'
    | '/store/admin/storefront'
    | '/merchandising/styles/$styleId/design/pack'
    | '/store/admin/collections/$collectionId/edit'
    | '/store/admin/products/$listingId/edit'
    | '/merchandising/styles/$styleId/design'
    | '/store/admin/buyers/$buyerId'
    | '/store/admin/collections/$collectionId'
    | '/store/admin/orders/$orderId'
    | '/store/admin/products/$listingId'
    | '/store/admin/quotes/$quoteId'
    | '/store/admin/sampling/$sampleId'
    | '/store/admin/storefront/$appearanceId'
    | '/store/admin/storefront/$appearanceId/preview'
    | '/store/admin/storefront/templates/$templateKey'
  id:
    | '__root__'
    | '/(workspace)'
    | '/launch'
    | '/pos'
    | '/subscription-ended'
    | '/(workspace)/documents'
    | '/(workspace)/payroll'
    | '/(workspace)/reports'
    | '/(workspace)/approvals'
    | '/(workspace)/'
    | '/station/'
    | '/(workspace)/cash/movements'
    | '/(workspace)/cash/petty-cash'
    | '/(workspace)/cash/reconcile'
    | '/(workspace)/cash/transfers'
    | '/(workspace)/compliance/books'
    | '/(workspace)/inventory/stock-transfers'
    | '/(auth)/join/$token'
    | '/(auth)/onboarding/account'
    | '/(auth)/onboarding/done'
    | '/(auth)/onboarding/tally'
    | '/(auth)/onboarding/workspace'
    | '/(auth)/sign-in/otp'
    | '/(workspace)/approvals/$approvalId'
    | '/(workspace)/ask/$chatId'
    | '/(workspace)/reports/$reportKey'
    | '/(workspace)/reports/new'
    | '/(auth)/sign-in/'
    | '/(workspace)/approvals/'
    | '/(workspace)/ask/'
    | '/(workspace)/documents/'
    | '/(workspace)/payroll/'
    | '/(workspace)/profile/'
    | '/(workspace)/reports/'
    | '/(workspace)/settings/'
    | '/(workspace)/cash/bank-accounts/new'
    | '/(workspace)/cash/movements/new'
    | '/(workspace)/cash/petty-cash/$voucherId'
    | '/(workspace)/cash/petty-cash/count'
    | '/(workspace)/cash/petty-cash/counts'
    | '/(workspace)/cash/petty-cash/new'
    | '/(workspace)/cash/petty-cash/replenish'
    | '/(workspace)/cash/transfers/$movementId'
    | '/(workspace)/cash/transfers/new'
    | '/(workspace)/inventory/stock-adjustments/new'
    | '/(workspace)/inventory/stock-transfers/new'
    | '/(workspace)/inventory/stock/opening'
    | '/(workspace)/inventory/warehouses/new'
    | '/(workspace)/merchandising/orders/new'
    | '/(workspace)/merchandising/styles/new'
    | '/(workspace)/payroll/employees/new'
    | '/(workspace)/procurement/bills/new'
    | '/(workspace)/procurement/goods-receipts/new'
    | '/(workspace)/procurement/purchase-orders/new'
    | '/(workspace)/procurement/vendors/new'
    | '/(workspace)/production/floor/$stage'
    | '/(workspace)/production/floor/inward'
    | '/(workspace)/sales/customers/new'
    | '/(workspace)/sales/invoices/new'
    | '/(workspace)/sales/items/new'
    | '/(workspace)/sales/proformas/new'
    | '/(workspace)/sales/receipts/$receiptId'
    | '/(workspace)/cash/bank-accounts/'
    | '/(workspace)/cash/petty-cash/'
    | '/(workspace)/cash/reconcile/'
    | '/(workspace)/cash/transfers/'
    | '/(workspace)/compliance/books/'
    | '/(workspace)/compliance/gst-returns/'
    | '/(workspace)/compliance/itc04/'
    | '/(workspace)/compliance/tds/'
    | '/(workspace)/inventory/stock-adjustments/'
    | '/(workspace)/inventory/stock-transfers/'
    | '/(workspace)/inventory/stock/'
    | '/(workspace)/inventory/warehouses/'
    | '/(workspace)/merchandising/orders/'
    | '/(workspace)/merchandising/risks/'
    | '/(workspace)/merchandising/styles/'
    | '/(workspace)/payroll/$runId/'
    | '/(workspace)/payroll/employees/'
    | '/(workspace)/pos/shifts/'
    | '/(workspace)/procurement/bills/'
    | '/(workspace)/procurement/goods-receipts/'
    | '/(workspace)/procurement/payments/'
    | '/(workspace)/procurement/purchase-orders/'
    | '/(workspace)/procurement/vendors/'
    | '/(workspace)/production/floor/'
    | '/(workspace)/records/audit-log/'
    | '/(workspace)/sales/collections/'
    | '/(workspace)/sales/customers/'
    | '/(workspace)/sales/invoices/'
    | '/(workspace)/sales/items/'
    | '/(workspace)/sales/proformas/'
    | '/(workspace)/sales/receipts/'
    | '/(workspace)/settings/about/'
    | '/(workspace)/settings/approvals/'
    | '/(workspace)/settings/assistant/'
    | '/(workspace)/settings/billing/'
    | '/(workspace)/settings/company/'
    | '/(workspace)/settings/gstin/'
    | '/(workspace)/settings/integrations/'
    | '/(workspace)/settings/notifications/'
    | '/(workspace)/settings/numbering/'
    | '/(workspace)/settings/profile/'
    | '/(workspace)/settings/recurring/'
    | '/(workspace)/settings/roles/'
    | '/(workspace)/settings/subscription/'
    | '/(workspace)/settings/team/'
    | '/(workspace)/settings/templates/'
    | '/(workspace)/store/admin/'
    | '/(workspace)/cash/bank-accounts/$bankAccountId/edit'
    | '/(workspace)/inventory/warehouses/$warehouseId/edit'
    | '/(workspace)/merchandising/orders/$orderId/edit'
    | '/(workspace)/merchandising/styles/$styleId/costing'
    | '/(workspace)/merchandising/styles/$styleId/dispatch'
    | '/(workspace)/merchandising/styles/$styleId/materials'
    | '/(workspace)/merchandising/styles/$styleId/overview'
    | '/(workspace)/merchandising/styles/$styleId/timeline'
    | '/(workspace)/merchandising/styles/$styleId/visual'
    | '/(workspace)/payroll/employees/$employeeId/edit'
    | '/(workspace)/procurement/bills/$billId/edit'
    | '/(workspace)/procurement/goods-receipts/$grnId/edit'
    | '/(workspace)/procurement/purchase-orders/$poId/edit'
    | '/(workspace)/procurement/vendors/$vendorId/edit'
    | '/(workspace)/production/styles/$styleId/production'
    | '/(workspace)/quality/styles/$styleId/qc'
    | '/(workspace)/sales/customers/$customerId/edit'
    | '/(workspace)/sales/customers/$customerId/ledger'
    | '/(workspace)/sales/invoices_/$invoiceId/edit'
    | '/(workspace)/sales/items/$itemId/edit'
    | '/(workspace)/sales/proformas_/$proformaId/edit'
    | '/(workspace)/sampling/styles/$styleId/samples'
    | '/(workspace)/store/admin/collections/new'
    | '/(workspace)/store/admin/products/new'
    | '/(workspace)/store/admin/quotes/new'
    | '/(workspace)/cash/bank-accounts/$bankAccountId/'
    | '/(workspace)/inventory/warehouses/$warehouseId/'
    | '/(workspace)/merchandising/orders/$orderId/'
    | '/(workspace)/merchandising/styles/$styleId/'
    | '/(workspace)/payroll/employees/$employeeId/'
    | '/(workspace)/procurement/bills/$billId/'
    | '/(workspace)/procurement/goods-receipts/$grnId/'
    | '/(workspace)/procurement/purchase-orders/$poId/'
    | '/(workspace)/procurement/vendors/$vendorId/'
    | '/(workspace)/sales/customers/$customerId/'
    | '/(workspace)/sales/invoices/$invoiceId/'
    | '/(workspace)/sales/items/$itemId/'
    | '/(workspace)/sales/proformas/$proformaId/'
    | '/(workspace)/store/admin/buyers/'
    | '/(workspace)/store/admin/collections/'
    | '/(workspace)/store/admin/orders/'
    | '/(workspace)/store/admin/packs/'
    | '/(workspace)/store/admin/pages/'
    | '/(workspace)/store/admin/products/'
    | '/(workspace)/store/admin/quotes/'
    | '/(workspace)/store/admin/reports/'
    | '/(workspace)/store/admin/returns/'
    | '/(workspace)/store/admin/sampling/'
    | '/(workspace)/store/admin/storefront/'
    | '/(workspace)/merchandising/styles/$styleId/design/pack'
    | '/(workspace)/store/admin/collections/$collectionId/edit'
    | '/(workspace)/store/admin/products/$listingId/edit'
    | '/(workspace)/merchandising/styles/$styleId/design/'
    | '/(workspace)/store/admin/buyers/$buyerId/'
    | '/(workspace)/store/admin/collections/$collectionId/'
    | '/(workspace)/store/admin/orders/$orderId/'
    | '/(workspace)/store/admin/products/$listingId/'
    | '/(workspace)/store/admin/quotes/$quoteId/'
    | '/(workspace)/store/admin/sampling/$sampleId/'
    | '/(workspace)/store/admin/storefront/$appearanceId/'
    | '/(workspace)/store/admin/storefront/$appearanceId/preview/'
    | '/(workspace)/store/admin/storefront/templates/$templateKey/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  workspaceRouteRoute: typeof workspaceRouteRouteWithChildren
  LaunchRoute: typeof LaunchRoute
  PosRoute: typeof PosRoute
  SubscriptionEndedRoute: typeof SubscriptionEndedRoute
  StationIndexRoute: typeof StationIndexRoute
  authJoinTokenRoute: typeof authJoinTokenRoute
  authOnboardingAccountRoute: typeof authOnboardingAccountRoute
  authOnboardingDoneRoute: typeof authOnboardingDoneRoute
  authOnboardingTallyRoute: typeof authOnboardingTallyRoute
  authOnboardingWorkspaceRoute: typeof authOnboardingWorkspaceRoute
  authSignInOtpRoute: typeof authSignInOtpRoute
  authSignInIndexRoute: typeof authSignInIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/subscription-ended': {
      id: '/subscription-ended'
      path: '/subscription-ended'
      fullPath: '/subscription-ended'
      preLoaderRoute: typeof SubscriptionEndedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pos': {
      id: '/pos'
      path: '/pos'
      fullPath: '/pos'
      preLoaderRoute: typeof PosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/launch': {
      id: '/launch'
      path: '/launch'
      fullPath: '/launch'
      preLoaderRoute: typeof LaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(workspace)': {
      id: '/(workspace)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof workspaceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/station/': {
      id: '/station/'
      path: '/station'
      fullPath: '/station/'
      preLoaderRoute: typeof StationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(workspace)/': {
      id: '/(workspace)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof workspaceIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/approvals': {
      id: '/(workspace)/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof workspaceApprovalsRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/reports': {
      id: '/(workspace)/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof workspaceReportsRouteRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/payroll': {
      id: '/(workspace)/payroll'
      path: '/payroll'
      fullPath: '/payroll'
      preLoaderRoute: typeof workspacePayrollRouteRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/documents': {
      id: '/(workspace)/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof workspaceDocumentsRouteRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/': {
      id: '/(workspace)/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof workspaceSettingsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/reports/': {
      id: '/(workspace)/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof workspaceReportsIndexRouteImport
      parentRoute: typeof workspaceReportsRouteRoute
    }
    '/(workspace)/profile/': {
      id: '/(workspace)/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof workspaceProfileIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/payroll/': {
      id: '/(workspace)/payroll/'
      path: '/'
      fullPath: '/payroll/'
      preLoaderRoute: typeof workspacePayrollIndexRouteImport
      parentRoute: typeof workspacePayrollRouteRoute
    }
    '/(workspace)/documents/': {
      id: '/(workspace)/documents/'
      path: '/'
      fullPath: '/documents/'
      preLoaderRoute: typeof workspaceDocumentsIndexRouteImport
      parentRoute: typeof workspaceDocumentsRouteRoute
    }
    '/(workspace)/ask/': {
      id: '/(workspace)/ask/'
      path: '/ask'
      fullPath: '/ask/'
      preLoaderRoute: typeof workspaceAskIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/approvals/': {
      id: '/(workspace)/approvals/'
      path: '/'
      fullPath: '/approvals/'
      preLoaderRoute: typeof workspaceApprovalsIndexRouteImport
      parentRoute: typeof workspaceApprovalsRoute
    }
    '/(auth)/sign-in/': {
      id: '/(auth)/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in/'
      preLoaderRoute: typeof authSignInIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(workspace)/reports/new': {
      id: '/(workspace)/reports/new'
      path: '/new'
      fullPath: '/reports/new'
      preLoaderRoute: typeof workspaceReportsNewRouteImport
      parentRoute: typeof workspaceReportsRouteRoute
    }
    '/(workspace)/reports/$reportKey': {
      id: '/(workspace)/reports/$reportKey'
      path: '/$reportKey'
      fullPath: '/reports/$reportKey'
      preLoaderRoute: typeof workspaceReportsReportKeyRouteImport
      parentRoute: typeof workspaceReportsRouteRoute
    }
    '/(workspace)/ask/$chatId': {
      id: '/(workspace)/ask/$chatId'
      path: '/ask/$chatId'
      fullPath: '/ask/$chatId'
      preLoaderRoute: typeof workspaceAskChatIdRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/approvals/$approvalId': {
      id: '/(workspace)/approvals/$approvalId'
      path: '/$approvalId'
      fullPath: '/approvals/$approvalId'
      preLoaderRoute: typeof workspaceApprovalsApprovalIdRouteImport
      parentRoute: typeof workspaceApprovalsRoute
    }
    '/(auth)/sign-in/otp': {
      id: '/(auth)/sign-in/otp'
      path: '/sign-in/otp'
      fullPath: '/sign-in/otp'
      preLoaderRoute: typeof authSignInOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/onboarding/workspace': {
      id: '/(auth)/onboarding/workspace'
      path: '/onboarding/workspace'
      fullPath: '/onboarding/workspace'
      preLoaderRoute: typeof authOnboardingWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/onboarding/tally': {
      id: '/(auth)/onboarding/tally'
      path: '/onboarding/tally'
      fullPath: '/onboarding/tally'
      preLoaderRoute: typeof authOnboardingTallyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/onboarding/done': {
      id: '/(auth)/onboarding/done'
      path: '/onboarding/done'
      fullPath: '/onboarding/done'
      preLoaderRoute: typeof authOnboardingDoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/onboarding/account': {
      id: '/(auth)/onboarding/account'
      path: '/onboarding/account'
      fullPath: '/onboarding/account'
      preLoaderRoute: typeof authOnboardingAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/join/$token': {
      id: '/(auth)/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof authJoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(workspace)/inventory/stock-transfers': {
      id: '/(workspace)/inventory/stock-transfers'
      path: '/inventory/stock-transfers'
      fullPath: '/inventory/stock-transfers'
      preLoaderRoute: typeof workspaceInventoryStockTransfersRouteRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/compliance/books': {
      id: '/(workspace)/compliance/books'
      path: '/compliance/books'
      fullPath: '/compliance/books'
      preLoaderRoute: typeof workspaceComplianceBooksRouteRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/cash/transfers': {
      id: '/(workspace)/cash/transfers'
      path: '/cash/transfers'
      fullPath: '/cash/transfers'
      preLoaderRoute: typeof workspaceCashTransfersRouteRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/cash/reconcile': {
      id: '/(workspace)/cash/reconcile'
      path: '/cash/reconcile'
      fullPath: '/cash/reconcile'
      preLoaderRoute: typeof workspaceCashReconcileRouteRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/cash/petty-cash': {
      id: '/(workspace)/cash/petty-cash'
      path: '/cash/petty-cash'
      fullPath: '/cash/petty-cash'
      preLoaderRoute: typeof workspaceCashPettyCashRouteRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/cash/movements': {
      id: '/(workspace)/cash/movements'
      path: '/cash/movements'
      fullPath: '/cash/movements'
      preLoaderRoute: typeof workspaceCashMovementsRouteRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/': {
      id: '/(workspace)/store/admin/'
      path: '/store/admin'
      fullPath: '/store/admin/'
      preLoaderRoute: typeof workspaceStoreAdminIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/templates/': {
      id: '/(workspace)/settings/templates/'
      path: '/settings/templates'
      fullPath: '/settings/templates/'
      preLoaderRoute: typeof workspaceSettingsTemplatesIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/team/': {
      id: '/(workspace)/settings/team/'
      path: '/settings/team'
      fullPath: '/settings/team/'
      preLoaderRoute: typeof workspaceSettingsTeamIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/subscription/': {
      id: '/(workspace)/settings/subscription/'
      path: '/settings/subscription'
      fullPath: '/settings/subscription/'
      preLoaderRoute: typeof workspaceSettingsSubscriptionIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/roles/': {
      id: '/(workspace)/settings/roles/'
      path: '/settings/roles'
      fullPath: '/settings/roles/'
      preLoaderRoute: typeof workspaceSettingsRolesIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/recurring/': {
      id: '/(workspace)/settings/recurring/'
      path: '/settings/recurring'
      fullPath: '/settings/recurring/'
      preLoaderRoute: typeof workspaceSettingsRecurringIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/profile/': {
      id: '/(workspace)/settings/profile/'
      path: '/settings/profile'
      fullPath: '/settings/profile/'
      preLoaderRoute: typeof workspaceSettingsProfileIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/numbering/': {
      id: '/(workspace)/settings/numbering/'
      path: '/settings/numbering'
      fullPath: '/settings/numbering/'
      preLoaderRoute: typeof workspaceSettingsNumberingIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/notifications/': {
      id: '/(workspace)/settings/notifications/'
      path: '/settings/notifications'
      fullPath: '/settings/notifications/'
      preLoaderRoute: typeof workspaceSettingsNotificationsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/integrations/': {
      id: '/(workspace)/settings/integrations/'
      path: '/settings/integrations'
      fullPath: '/settings/integrations/'
      preLoaderRoute: typeof workspaceSettingsIntegrationsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/gstin/': {
      id: '/(workspace)/settings/gstin/'
      path: '/settings/gstin'
      fullPath: '/settings/gstin/'
      preLoaderRoute: typeof workspaceSettingsGstinIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/company/': {
      id: '/(workspace)/settings/company/'
      path: '/settings/company'
      fullPath: '/settings/company/'
      preLoaderRoute: typeof workspaceSettingsCompanyIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/billing/': {
      id: '/(workspace)/settings/billing/'
      path: '/settings/billing'
      fullPath: '/settings/billing/'
      preLoaderRoute: typeof workspaceSettingsBillingIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/assistant/': {
      id: '/(workspace)/settings/assistant/'
      path: '/settings/assistant'
      fullPath: '/settings/assistant/'
      preLoaderRoute: typeof workspaceSettingsAssistantIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/approvals/': {
      id: '/(workspace)/settings/approvals/'
      path: '/settings/approvals'
      fullPath: '/settings/approvals/'
      preLoaderRoute: typeof workspaceSettingsApprovalsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/settings/about/': {
      id: '/(workspace)/settings/about/'
      path: '/settings/about'
      fullPath: '/settings/about/'
      preLoaderRoute: typeof workspaceSettingsAboutIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/receipts/': {
      id: '/(workspace)/sales/receipts/'
      path: '/sales/receipts'
      fullPath: '/sales/receipts/'
      preLoaderRoute: typeof workspaceSalesReceiptsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/proformas/': {
      id: '/(workspace)/sales/proformas/'
      path: '/sales/proformas'
      fullPath: '/sales/proformas/'
      preLoaderRoute: typeof workspaceSalesProformasIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/items/': {
      id: '/(workspace)/sales/items/'
      path: '/sales/items'
      fullPath: '/sales/items/'
      preLoaderRoute: typeof workspaceSalesItemsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/invoices/': {
      id: '/(workspace)/sales/invoices/'
      path: '/sales/invoices'
      fullPath: '/sales/invoices/'
      preLoaderRoute: typeof workspaceSalesInvoicesIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/customers/': {
      id: '/(workspace)/sales/customers/'
      path: '/sales/customers'
      fullPath: '/sales/customers/'
      preLoaderRoute: typeof workspaceSalesCustomersIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/collections/': {
      id: '/(workspace)/sales/collections/'
      path: '/sales/collections'
      fullPath: '/sales/collections/'
      preLoaderRoute: typeof workspaceSalesCollectionsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/records/audit-log/': {
      id: '/(workspace)/records/audit-log/'
      path: '/records/audit-log'
      fullPath: '/records/audit-log/'
      preLoaderRoute: typeof workspaceRecordsAuditLogIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/production/floor/': {
      id: '/(workspace)/production/floor/'
      path: '/production/floor'
      fullPath: '/production/floor/'
      preLoaderRoute: typeof workspaceProductionFloorIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/vendors/': {
      id: '/(workspace)/procurement/vendors/'
      path: '/procurement/vendors'
      fullPath: '/procurement/vendors/'
      preLoaderRoute: typeof workspaceProcurementVendorsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/purchase-orders/': {
      id: '/(workspace)/procurement/purchase-orders/'
      path: '/procurement/purchase-orders'
      fullPath: '/procurement/purchase-orders/'
      preLoaderRoute: typeof workspaceProcurementPurchaseOrdersIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/payments/': {
      id: '/(workspace)/procurement/payments/'
      path: '/procurement/payments'
      fullPath: '/procurement/payments/'
      preLoaderRoute: typeof workspaceProcurementPaymentsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/goods-receipts/': {
      id: '/(workspace)/procurement/goods-receipts/'
      path: '/procurement/goods-receipts'
      fullPath: '/procurement/goods-receipts/'
      preLoaderRoute: typeof workspaceProcurementGoodsReceiptsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/bills/': {
      id: '/(workspace)/procurement/bills/'
      path: '/procurement/bills'
      fullPath: '/procurement/bills/'
      preLoaderRoute: typeof workspaceProcurementBillsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/pos/shifts/': {
      id: '/(workspace)/pos/shifts/'
      path: '/pos/shifts'
      fullPath: '/pos/shifts/'
      preLoaderRoute: typeof workspacePosShiftsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/payroll/employees/': {
      id: '/(workspace)/payroll/employees/'
      path: '/employees'
      fullPath: '/payroll/employees/'
      preLoaderRoute: typeof workspacePayrollEmployeesIndexRouteImport
      parentRoute: typeof workspacePayrollRouteRoute
    }
    '/(workspace)/payroll/$runId/': {
      id: '/(workspace)/payroll/$runId/'
      path: '/$runId'
      fullPath: '/payroll/$runId/'
      preLoaderRoute: typeof workspacePayrollRunIdIndexRouteImport
      parentRoute: typeof workspacePayrollRouteRoute
    }
    '/(workspace)/merchandising/styles/': {
      id: '/(workspace)/merchandising/styles/'
      path: '/merchandising/styles'
      fullPath: '/merchandising/styles/'
      preLoaderRoute: typeof workspaceMerchandisingStylesIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/merchandising/risks/': {
      id: '/(workspace)/merchandising/risks/'
      path: '/merchandising/risks'
      fullPath: '/merchandising/risks/'
      preLoaderRoute: typeof workspaceMerchandisingRisksIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/merchandising/orders/': {
      id: '/(workspace)/merchandising/orders/'
      path: '/merchandising/orders'
      fullPath: '/merchandising/orders/'
      preLoaderRoute: typeof workspaceMerchandisingOrdersIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/inventory/warehouses/': {
      id: '/(workspace)/inventory/warehouses/'
      path: '/inventory/warehouses'
      fullPath: '/inventory/warehouses/'
      preLoaderRoute: typeof workspaceInventoryWarehousesIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/inventory/stock/': {
      id: '/(workspace)/inventory/stock/'
      path: '/inventory/stock'
      fullPath: '/inventory/stock/'
      preLoaderRoute: typeof workspaceInventoryStockIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/inventory/stock-transfers/': {
      id: '/(workspace)/inventory/stock-transfers/'
      path: '/'
      fullPath: '/inventory/stock-transfers/'
      preLoaderRoute: typeof workspaceInventoryStockTransfersIndexRouteImport
      parentRoute: typeof workspaceInventoryStockTransfersRouteRoute
    }
    '/(workspace)/inventory/stock-adjustments/': {
      id: '/(workspace)/inventory/stock-adjustments/'
      path: '/inventory/stock-adjustments'
      fullPath: '/inventory/stock-adjustments/'
      preLoaderRoute: typeof workspaceInventoryStockAdjustmentsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/compliance/tds/': {
      id: '/(workspace)/compliance/tds/'
      path: '/compliance/tds'
      fullPath: '/compliance/tds/'
      preLoaderRoute: typeof workspaceComplianceTdsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/compliance/itc04/': {
      id: '/(workspace)/compliance/itc04/'
      path: '/compliance/itc04'
      fullPath: '/compliance/itc04/'
      preLoaderRoute: typeof workspaceComplianceItc04IndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/compliance/gst-returns/': {
      id: '/(workspace)/compliance/gst-returns/'
      path: '/compliance/gst-returns'
      fullPath: '/compliance/gst-returns/'
      preLoaderRoute: typeof workspaceComplianceGstReturnsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/compliance/books/': {
      id: '/(workspace)/compliance/books/'
      path: '/'
      fullPath: '/compliance/books/'
      preLoaderRoute: typeof workspaceComplianceBooksIndexRouteImport
      parentRoute: typeof workspaceComplianceBooksRouteRoute
    }
    '/(workspace)/cash/transfers/': {
      id: '/(workspace)/cash/transfers/'
      path: '/'
      fullPath: '/cash/transfers/'
      preLoaderRoute: typeof workspaceCashTransfersIndexRouteImport
      parentRoute: typeof workspaceCashTransfersRouteRoute
    }
    '/(workspace)/cash/reconcile/': {
      id: '/(workspace)/cash/reconcile/'
      path: '/'
      fullPath: '/cash/reconcile/'
      preLoaderRoute: typeof workspaceCashReconcileIndexRouteImport
      parentRoute: typeof workspaceCashReconcileRouteRoute
    }
    '/(workspace)/cash/petty-cash/': {
      id: '/(workspace)/cash/petty-cash/'
      path: '/'
      fullPath: '/cash/petty-cash/'
      preLoaderRoute: typeof workspaceCashPettyCashIndexRouteImport
      parentRoute: typeof workspaceCashPettyCashRouteRoute
    }
    '/(workspace)/cash/bank-accounts/': {
      id: '/(workspace)/cash/bank-accounts/'
      path: '/cash/bank-accounts'
      fullPath: '/cash/bank-accounts/'
      preLoaderRoute: typeof workspaceCashBankAccountsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/receipts/$receiptId': {
      id: '/(workspace)/sales/receipts/$receiptId'
      path: '/sales/receipts/$receiptId'
      fullPath: '/sales/receipts/$receiptId'
      preLoaderRoute: typeof workspaceSalesReceiptsReceiptIdRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/proformas/new': {
      id: '/(workspace)/sales/proformas/new'
      path: '/sales/proformas/new'
      fullPath: '/sales/proformas/new'
      preLoaderRoute: typeof workspaceSalesProformasNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/items/new': {
      id: '/(workspace)/sales/items/new'
      path: '/sales/items/new'
      fullPath: '/sales/items/new'
      preLoaderRoute: typeof workspaceSalesItemsNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/invoices/new': {
      id: '/(workspace)/sales/invoices/new'
      path: '/sales/invoices/new'
      fullPath: '/sales/invoices/new'
      preLoaderRoute: typeof workspaceSalesInvoicesNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/customers/new': {
      id: '/(workspace)/sales/customers/new'
      path: '/sales/customers/new'
      fullPath: '/sales/customers/new'
      preLoaderRoute: typeof workspaceSalesCustomersNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/production/floor/inward': {
      id: '/(workspace)/production/floor/inward'
      path: '/production/floor/inward'
      fullPath: '/production/floor/inward'
      preLoaderRoute: typeof workspaceProductionFloorInwardRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/production/floor/$stage': {
      id: '/(workspace)/production/floor/$stage'
      path: '/production/floor/$stage'
      fullPath: '/production/floor/$stage'
      preLoaderRoute: typeof workspaceProductionFloorStageRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/vendors/new': {
      id: '/(workspace)/procurement/vendors/new'
      path: '/procurement/vendors/new'
      fullPath: '/procurement/vendors/new'
      preLoaderRoute: typeof workspaceProcurementVendorsNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/purchase-orders/new': {
      id: '/(workspace)/procurement/purchase-orders/new'
      path: '/procurement/purchase-orders/new'
      fullPath: '/procurement/purchase-orders/new'
      preLoaderRoute: typeof workspaceProcurementPurchaseOrdersNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/goods-receipts/new': {
      id: '/(workspace)/procurement/goods-receipts/new'
      path: '/procurement/goods-receipts/new'
      fullPath: '/procurement/goods-receipts/new'
      preLoaderRoute: typeof workspaceProcurementGoodsReceiptsNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/bills/new': {
      id: '/(workspace)/procurement/bills/new'
      path: '/procurement/bills/new'
      fullPath: '/procurement/bills/new'
      preLoaderRoute: typeof workspaceProcurementBillsNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/payroll/employees/new': {
      id: '/(workspace)/payroll/employees/new'
      path: '/employees/new'
      fullPath: '/payroll/employees/new'
      preLoaderRoute: typeof workspacePayrollEmployeesNewRouteImport
      parentRoute: typeof workspacePayrollRouteRoute
    }
    '/(workspace)/merchandising/styles/new': {
      id: '/(workspace)/merchandising/styles/new'
      path: '/merchandising/styles/new'
      fullPath: '/merchandising/styles/new'
      preLoaderRoute: typeof workspaceMerchandisingStylesNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/merchandising/orders/new': {
      id: '/(workspace)/merchandising/orders/new'
      path: '/merchandising/orders/new'
      fullPath: '/merchandising/orders/new'
      preLoaderRoute: typeof workspaceMerchandisingOrdersNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/inventory/warehouses/new': {
      id: '/(workspace)/inventory/warehouses/new'
      path: '/inventory/warehouses/new'
      fullPath: '/inventory/warehouses/new'
      preLoaderRoute: typeof workspaceInventoryWarehousesNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/inventory/stock/opening': {
      id: '/(workspace)/inventory/stock/opening'
      path: '/inventory/stock/opening'
      fullPath: '/inventory/stock/opening'
      preLoaderRoute: typeof workspaceInventoryStockOpeningRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/inventory/stock-transfers/new': {
      id: '/(workspace)/inventory/stock-transfers/new'
      path: '/new'
      fullPath: '/inventory/stock-transfers/new'
      preLoaderRoute: typeof workspaceInventoryStockTransfersNewRouteImport
      parentRoute: typeof workspaceInventoryStockTransfersRouteRoute
    }
    '/(workspace)/inventory/stock-adjustments/new': {
      id: '/(workspace)/inventory/stock-adjustments/new'
      path: '/inventory/stock-adjustments/new'
      fullPath: '/inventory/stock-adjustments/new'
      preLoaderRoute: typeof workspaceInventoryStockAdjustmentsNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/cash/transfers/new': {
      id: '/(workspace)/cash/transfers/new'
      path: '/new'
      fullPath: '/cash/transfers/new'
      preLoaderRoute: typeof workspaceCashTransfersNewRouteImport
      parentRoute: typeof workspaceCashTransfersRouteRoute
    }
    '/(workspace)/cash/transfers/$movementId': {
      id: '/(workspace)/cash/transfers/$movementId'
      path: '/$movementId'
      fullPath: '/cash/transfers/$movementId'
      preLoaderRoute: typeof workspaceCashTransfersMovementIdRouteImport
      parentRoute: typeof workspaceCashTransfersRouteRoute
    }
    '/(workspace)/cash/petty-cash/replenish': {
      id: '/(workspace)/cash/petty-cash/replenish'
      path: '/replenish'
      fullPath: '/cash/petty-cash/replenish'
      preLoaderRoute: typeof workspaceCashPettyCashReplenishRouteImport
      parentRoute: typeof workspaceCashPettyCashRouteRoute
    }
    '/(workspace)/cash/petty-cash/new': {
      id: '/(workspace)/cash/petty-cash/new'
      path: '/new'
      fullPath: '/cash/petty-cash/new'
      preLoaderRoute: typeof workspaceCashPettyCashNewRouteImport
      parentRoute: typeof workspaceCashPettyCashRouteRoute
    }
    '/(workspace)/cash/petty-cash/counts': {
      id: '/(workspace)/cash/petty-cash/counts'
      path: '/counts'
      fullPath: '/cash/petty-cash/counts'
      preLoaderRoute: typeof workspaceCashPettyCashCountsRouteImport
      parentRoute: typeof workspaceCashPettyCashRouteRoute
    }
    '/(workspace)/cash/petty-cash/count': {
      id: '/(workspace)/cash/petty-cash/count'
      path: '/count'
      fullPath: '/cash/petty-cash/count'
      preLoaderRoute: typeof workspaceCashPettyCashCountRouteImport
      parentRoute: typeof workspaceCashPettyCashRouteRoute
    }
    '/(workspace)/cash/petty-cash/$voucherId': {
      id: '/(workspace)/cash/petty-cash/$voucherId'
      path: '/$voucherId'
      fullPath: '/cash/petty-cash/$voucherId'
      preLoaderRoute: typeof workspaceCashPettyCashVoucherIdRouteImport
      parentRoute: typeof workspaceCashPettyCashRouteRoute
    }
    '/(workspace)/cash/movements/new': {
      id: '/(workspace)/cash/movements/new'
      path: '/new'
      fullPath: '/cash/movements/new'
      preLoaderRoute: typeof workspaceCashMovementsNewRouteImport
      parentRoute: typeof workspaceCashMovementsRouteRoute
    }
    '/(workspace)/cash/bank-accounts/new': {
      id: '/(workspace)/cash/bank-accounts/new'
      path: '/cash/bank-accounts/new'
      fullPath: '/cash/bank-accounts/new'
      preLoaderRoute: typeof workspaceCashBankAccountsNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/storefront/': {
      id: '/(workspace)/store/admin/storefront/'
      path: '/store/admin/storefront'
      fullPath: '/store/admin/storefront/'
      preLoaderRoute: typeof workspaceStoreAdminStorefrontIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/sampling/': {
      id: '/(workspace)/store/admin/sampling/'
      path: '/store/admin/sampling'
      fullPath: '/store/admin/sampling/'
      preLoaderRoute: typeof workspaceStoreAdminSamplingIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/returns/': {
      id: '/(workspace)/store/admin/returns/'
      path: '/store/admin/returns'
      fullPath: '/store/admin/returns/'
      preLoaderRoute: typeof workspaceStoreAdminReturnsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/reports/': {
      id: '/(workspace)/store/admin/reports/'
      path: '/store/admin/reports'
      fullPath: '/store/admin/reports/'
      preLoaderRoute: typeof workspaceStoreAdminReportsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/quotes/': {
      id: '/(workspace)/store/admin/quotes/'
      path: '/store/admin/quotes'
      fullPath: '/store/admin/quotes/'
      preLoaderRoute: typeof workspaceStoreAdminQuotesIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/products/': {
      id: '/(workspace)/store/admin/products/'
      path: '/store/admin/products'
      fullPath: '/store/admin/products/'
      preLoaderRoute: typeof workspaceStoreAdminProductsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/pages/': {
      id: '/(workspace)/store/admin/pages/'
      path: '/store/admin/pages'
      fullPath: '/store/admin/pages/'
      preLoaderRoute: typeof workspaceStoreAdminPagesIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/packs/': {
      id: '/(workspace)/store/admin/packs/'
      path: '/store/admin/packs'
      fullPath: '/store/admin/packs/'
      preLoaderRoute: typeof workspaceStoreAdminPacksIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/orders/': {
      id: '/(workspace)/store/admin/orders/'
      path: '/store/admin/orders'
      fullPath: '/store/admin/orders/'
      preLoaderRoute: typeof workspaceStoreAdminOrdersIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/collections/': {
      id: '/(workspace)/store/admin/collections/'
      path: '/store/admin/collections'
      fullPath: '/store/admin/collections/'
      preLoaderRoute: typeof workspaceStoreAdminCollectionsIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/buyers/': {
      id: '/(workspace)/store/admin/buyers/'
      path: '/store/admin/buyers'
      fullPath: '/store/admin/buyers/'
      preLoaderRoute: typeof workspaceStoreAdminBuyersIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/proformas/$proformaId/': {
      id: '/(workspace)/sales/proformas/$proformaId/'
      path: '/sales/proformas/$proformaId'
      fullPath: '/sales/proformas/$proformaId/'
      preLoaderRoute: typeof workspaceSalesProformasProformaIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/items/$itemId/': {
      id: '/(workspace)/sales/items/$itemId/'
      path: '/sales/items/$itemId'
      fullPath: '/sales/items/$itemId/'
      preLoaderRoute: typeof workspaceSalesItemsItemIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/invoices/$invoiceId/': {
      id: '/(workspace)/sales/invoices/$invoiceId/'
      path: '/sales/invoices/$invoiceId'
      fullPath: '/sales/invoices/$invoiceId/'
      preLoaderRoute: typeof workspaceSalesInvoicesInvoiceIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/customers/$customerId/': {
      id: '/(workspace)/sales/customers/$customerId/'
      path: '/sales/customers/$customerId'
      fullPath: '/sales/customers/$customerId/'
      preLoaderRoute: typeof workspaceSalesCustomersCustomerIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/vendors/$vendorId/': {
      id: '/(workspace)/procurement/vendors/$vendorId/'
      path: '/procurement/vendors/$vendorId'
      fullPath: '/procurement/vendors/$vendorId/'
      preLoaderRoute: typeof workspaceProcurementVendorsVendorIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/purchase-orders/$poId/': {
      id: '/(workspace)/procurement/purchase-orders/$poId/'
      path: '/procurement/purchase-orders/$poId'
      fullPath: '/procurement/purchase-orders/$poId/'
      preLoaderRoute: typeof workspaceProcurementPurchaseOrdersPoIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/goods-receipts/$grnId/': {
      id: '/(workspace)/procurement/goods-receipts/$grnId/'
      path: '/procurement/goods-receipts/$grnId'
      fullPath: '/procurement/goods-receipts/$grnId/'
      preLoaderRoute: typeof workspaceProcurementGoodsReceiptsGrnIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/bills/$billId/': {
      id: '/(workspace)/procurement/bills/$billId/'
      path: '/procurement/bills/$billId'
      fullPath: '/procurement/bills/$billId/'
      preLoaderRoute: typeof workspaceProcurementBillsBillIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/payroll/employees/$employeeId/': {
      id: '/(workspace)/payroll/employees/$employeeId/'
      path: '/employees/$employeeId'
      fullPath: '/payroll/employees/$employeeId/'
      preLoaderRoute: typeof workspacePayrollEmployeesEmployeeIdIndexRouteImport
      parentRoute: typeof workspacePayrollRouteRoute
    }
    '/(workspace)/merchandising/styles/$styleId/': {
      id: '/(workspace)/merchandising/styles/$styleId/'
      path: '/merchandising/styles/$styleId'
      fullPath: '/merchandising/styles/$styleId/'
      preLoaderRoute: typeof workspaceMerchandisingStylesStyleIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/merchandising/orders/$orderId/': {
      id: '/(workspace)/merchandising/orders/$orderId/'
      path: '/merchandising/orders/$orderId'
      fullPath: '/merchandising/orders/$orderId/'
      preLoaderRoute: typeof workspaceMerchandisingOrdersOrderIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/inventory/warehouses/$warehouseId/': {
      id: '/(workspace)/inventory/warehouses/$warehouseId/'
      path: '/inventory/warehouses/$warehouseId'
      fullPath: '/inventory/warehouses/$warehouseId/'
      preLoaderRoute: typeof workspaceInventoryWarehousesWarehouseIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/cash/bank-accounts/$bankAccountId/': {
      id: '/(workspace)/cash/bank-accounts/$bankAccountId/'
      path: '/cash/bank-accounts/$bankAccountId'
      fullPath: '/cash/bank-accounts/$bankAccountId/'
      preLoaderRoute: typeof workspaceCashBankAccountsBankAccountIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/quotes/new': {
      id: '/(workspace)/store/admin/quotes/new'
      path: '/store/admin/quotes/new'
      fullPath: '/store/admin/quotes/new'
      preLoaderRoute: typeof workspaceStoreAdminQuotesNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/products/new': {
      id: '/(workspace)/store/admin/products/new'
      path: '/store/admin/products/new'
      fullPath: '/store/admin/products/new'
      preLoaderRoute: typeof workspaceStoreAdminProductsNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/collections/new': {
      id: '/(workspace)/store/admin/collections/new'
      path: '/store/admin/collections/new'
      fullPath: '/store/admin/collections/new'
      preLoaderRoute: typeof workspaceStoreAdminCollectionsNewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sampling/styles/$styleId/samples': {
      id: '/(workspace)/sampling/styles/$styleId/samples'
      path: '/sampling/styles/$styleId/samples'
      fullPath: '/sampling/styles/$styleId/samples'
      preLoaderRoute: typeof workspaceSamplingStylesStyleIdSamplesRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/proformas_/$proformaId/edit': {
      id: '/(workspace)/sales/proformas_/$proformaId/edit'
      path: '/sales/proformas/$proformaId/edit'
      fullPath: '/sales/proformas/$proformaId/edit'
      preLoaderRoute: typeof workspaceSalesProformasProformaIdEditRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/items/$itemId/edit': {
      id: '/(workspace)/sales/items/$itemId/edit'
      path: '/sales/items/$itemId/edit'
      fullPath: '/sales/items/$itemId/edit'
      preLoaderRoute: typeof workspaceSalesItemsItemIdEditRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/invoices_/$invoiceId/edit': {
      id: '/(workspace)/sales/invoices_/$invoiceId/edit'
      path: '/sales/invoices/$invoiceId/edit'
      fullPath: '/sales/invoices/$invoiceId/edit'
      preLoaderRoute: typeof workspaceSalesInvoicesInvoiceIdEditRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/customers/$customerId/ledger': {
      id: '/(workspace)/sales/customers/$customerId/ledger'
      path: '/sales/customers/$customerId/ledger'
      fullPath: '/sales/customers/$customerId/ledger'
      preLoaderRoute: typeof workspaceSalesCustomersCustomerIdLedgerRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/sales/customers/$customerId/edit': {
      id: '/(workspace)/sales/customers/$customerId/edit'
      path: '/sales/customers/$customerId/edit'
      fullPath: '/sales/customers/$customerId/edit'
      preLoaderRoute: typeof workspaceSalesCustomersCustomerIdEditRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/quality/styles/$styleId/qc': {
      id: '/(workspace)/quality/styles/$styleId/qc'
      path: '/quality/styles/$styleId/qc'
      fullPath: '/quality/styles/$styleId/qc'
      preLoaderRoute: typeof workspaceQualityStylesStyleIdQcRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/production/styles/$styleId/production': {
      id: '/(workspace)/production/styles/$styleId/production'
      path: '/production/styles/$styleId/production'
      fullPath: '/production/styles/$styleId/production'
      preLoaderRoute: typeof workspaceProductionStylesStyleIdProductionRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/vendors/$vendorId/edit': {
      id: '/(workspace)/procurement/vendors/$vendorId/edit'
      path: '/procurement/vendors/$vendorId/edit'
      fullPath: '/procurement/vendors/$vendorId/edit'
      preLoaderRoute: typeof workspaceProcurementVendorsVendorIdEditRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/purchase-orders/$poId/edit': {
      id: '/(workspace)/procurement/purchase-orders/$poId/edit'
      path: '/procurement/purchase-orders/$poId/edit'
      fullPath: '/procurement/purchase-orders/$poId/edit'
      preLoaderRoute: typeof workspaceProcurementPurchaseOrdersPoIdEditRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/goods-receipts/$grnId/edit': {
      id: '/(workspace)/procurement/goods-receipts/$grnId/edit'
      path: '/procurement/goods-receipts/$grnId/edit'
      fullPath: '/procurement/goods-receipts/$grnId/edit'
      preLoaderRoute: typeof workspaceProcurementGoodsReceiptsGrnIdEditRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/procurement/bills/$billId/edit': {
      id: '/(workspace)/procurement/bills/$billId/edit'
      path: '/procurement/bills/$billId/edit'
      fullPath: '/procurement/bills/$billId/edit'
      preLoaderRoute: typeof workspaceProcurementBillsBillIdEditRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/payroll/employees/$employeeId/edit': {
      id: '/(workspace)/payroll/employees/$employeeId/edit'
      path: '/employees/$employeeId/edit'
      fullPath: '/payroll/employees/$employeeId/edit'
      preLoaderRoute: typeof workspacePayrollEmployeesEmployeeIdEditRouteImport
      parentRoute: typeof workspacePayrollRouteRoute
    }
    '/(workspace)/merchandising/styles/$styleId/visual': {
      id: '/(workspace)/merchandising/styles/$styleId/visual'
      path: '/merchandising/styles/$styleId/visual'
      fullPath: '/merchandising/styles/$styleId/visual'
      preLoaderRoute: typeof workspaceMerchandisingStylesStyleIdVisualRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/merchandising/styles/$styleId/timeline': {
      id: '/(workspace)/merchandising/styles/$styleId/timeline'
      path: '/merchandising/styles/$styleId/timeline'
      fullPath: '/merchandising/styles/$styleId/timeline'
      preLoaderRoute: typeof workspaceMerchandisingStylesStyleIdTimelineRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/merchandising/styles/$styleId/overview': {
      id: '/(workspace)/merchandising/styles/$styleId/overview'
      path: '/merchandising/styles/$styleId/overview'
      fullPath: '/merchandising/styles/$styleId/overview'
      preLoaderRoute: typeof workspaceMerchandisingStylesStyleIdOverviewRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/merchandising/styles/$styleId/materials': {
      id: '/(workspace)/merchandising/styles/$styleId/materials'
      path: '/merchandising/styles/$styleId/materials'
      fullPath: '/merchandising/styles/$styleId/materials'
      preLoaderRoute: typeof workspaceMerchandisingStylesStyleIdMaterialsRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/merchandising/styles/$styleId/dispatch': {
      id: '/(workspace)/merchandising/styles/$styleId/dispatch'
      path: '/merchandising/styles/$styleId/dispatch'
      fullPath: '/merchandising/styles/$styleId/dispatch'
      preLoaderRoute: typeof workspaceMerchandisingStylesStyleIdDispatchRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/merchandising/styles/$styleId/costing': {
      id: '/(workspace)/merchandising/styles/$styleId/costing'
      path: '/merchandising/styles/$styleId/costing'
      fullPath: '/merchandising/styles/$styleId/costing'
      preLoaderRoute: typeof workspaceMerchandisingStylesStyleIdCostingRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/merchandising/orders/$orderId/edit': {
      id: '/(workspace)/merchandising/orders/$orderId/edit'
      path: '/merchandising/orders/$orderId/edit'
      fullPath: '/merchandising/orders/$orderId/edit'
      preLoaderRoute: typeof workspaceMerchandisingOrdersOrderIdEditRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/inventory/warehouses/$warehouseId/edit': {
      id: '/(workspace)/inventory/warehouses/$warehouseId/edit'
      path: '/inventory/warehouses/$warehouseId/edit'
      fullPath: '/inventory/warehouses/$warehouseId/edit'
      preLoaderRoute: typeof workspaceInventoryWarehousesWarehouseIdEditRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/cash/bank-accounts/$bankAccountId/edit': {
      id: '/(workspace)/cash/bank-accounts/$bankAccountId/edit'
      path: '/cash/bank-accounts/$bankAccountId/edit'
      fullPath: '/cash/bank-accounts/$bankAccountId/edit'
      preLoaderRoute: typeof workspaceCashBankAccountsBankAccountIdEditRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/storefront/$appearanceId/': {
      id: '/(workspace)/store/admin/storefront/$appearanceId/'
      path: '/store/admin/storefront/$appearanceId'
      fullPath: '/store/admin/storefront/$appearanceId/'
      preLoaderRoute: typeof workspaceStoreAdminStorefrontAppearanceIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/sampling/$sampleId/': {
      id: '/(workspace)/store/admin/sampling/$sampleId/'
      path: '/store/admin/sampling/$sampleId'
      fullPath: '/store/admin/sampling/$sampleId/'
      preLoaderRoute: typeof workspaceStoreAdminSamplingSampleIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/quotes/$quoteId/': {
      id: '/(workspace)/store/admin/quotes/$quoteId/'
      path: '/store/admin/quotes/$quoteId'
      fullPath: '/store/admin/quotes/$quoteId/'
      preLoaderRoute: typeof workspaceStoreAdminQuotesQuoteIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/products/$listingId/': {
      id: '/(workspace)/store/admin/products/$listingId/'
      path: '/store/admin/products/$listingId'
      fullPath: '/store/admin/products/$listingId/'
      preLoaderRoute: typeof workspaceStoreAdminProductsListingIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/orders/$orderId/': {
      id: '/(workspace)/store/admin/orders/$orderId/'
      path: '/store/admin/orders/$orderId'
      fullPath: '/store/admin/orders/$orderId/'
      preLoaderRoute: typeof workspaceStoreAdminOrdersOrderIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/collections/$collectionId/': {
      id: '/(workspace)/store/admin/collections/$collectionId/'
      path: '/store/admin/collections/$collectionId'
      fullPath: '/store/admin/collections/$collectionId/'
      preLoaderRoute: typeof workspaceStoreAdminCollectionsCollectionIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/buyers/$buyerId/': {
      id: '/(workspace)/store/admin/buyers/$buyerId/'
      path: '/store/admin/buyers/$buyerId'
      fullPath: '/store/admin/buyers/$buyerId/'
      preLoaderRoute: typeof workspaceStoreAdminBuyersBuyerIdIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/merchandising/styles/$styleId/design/': {
      id: '/(workspace)/merchandising/styles/$styleId/design/'
      path: '/merchandising/styles/$styleId/design'
      fullPath: '/merchandising/styles/$styleId/design/'
      preLoaderRoute: typeof workspaceMerchandisingStylesStyleIdDesignIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/products/$listingId/edit': {
      id: '/(workspace)/store/admin/products/$listingId/edit'
      path: '/store/admin/products/$listingId/edit'
      fullPath: '/store/admin/products/$listingId/edit'
      preLoaderRoute: typeof workspaceStoreAdminProductsListingIdEditRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/collections/$collectionId/edit': {
      id: '/(workspace)/store/admin/collections/$collectionId/edit'
      path: '/store/admin/collections/$collectionId/edit'
      fullPath: '/store/admin/collections/$collectionId/edit'
      preLoaderRoute: typeof workspaceStoreAdminCollectionsCollectionIdEditRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/merchandising/styles/$styleId/design/pack': {
      id: '/(workspace)/merchandising/styles/$styleId/design/pack'
      path: '/merchandising/styles/$styleId/design/pack'
      fullPath: '/merchandising/styles/$styleId/design/pack'
      preLoaderRoute: typeof workspaceMerchandisingStylesStyleIdDesignPackRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/storefront/templates/$templateKey/': {
      id: '/(workspace)/store/admin/storefront/templates/$templateKey/'
      path: '/store/admin/storefront/templates/$templateKey'
      fullPath: '/store/admin/storefront/templates/$templateKey/'
      preLoaderRoute: typeof workspaceStoreAdminStorefrontTemplatesTemplateKeyIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
    '/(workspace)/store/admin/storefront/$appearanceId/preview/': {
      id: '/(workspace)/store/admin/storefront/$appearanceId/preview/'
      path: '/store/admin/storefront/$appearanceId/preview'
      fullPath: '/store/admin/storefront/$appearanceId/preview/'
      preLoaderRoute: typeof workspaceStoreAdminStorefrontAppearanceIdPreviewIndexRouteImport
      parentRoute: typeof workspaceRouteRoute
    }
  }
}

interface workspaceDocumentsRouteRouteChildren {
  workspaceDocumentsIndexRoute: typeof workspaceDocumentsIndexRoute
}

const workspaceDocumentsRouteRouteChildren: workspaceDocumentsRouteRouteChildren =
  {
    workspaceDocumentsIndexRoute: workspaceDocumentsIndexRoute,
  }

const workspaceDocumentsRouteRouteWithChildren =
  workspaceDocumentsRouteRoute._addFileChildren(
    workspaceDocumentsRouteRouteChildren,
  )

interface workspacePayrollRouteRouteChildren {
  workspacePayrollIndexRoute: typeof workspacePayrollIndexRoute
  workspacePayrollEmployeesNewRoute: typeof workspacePayrollEmployeesNewRoute
  workspacePayrollRunIdIndexRoute: typeof workspacePayrollRunIdIndexRoute
  workspacePayrollEmployeesIndexRoute: typeof workspacePayrollEmployeesIndexRoute
  workspacePayrollEmployeesEmployeeIdEditRoute: typeof workspacePayrollEmployeesEmployeeIdEditRoute
  workspacePayrollEmployeesEmployeeIdIndexRoute: typeof workspacePayrollEmployeesEmployeeIdIndexRoute
}

const workspacePayrollRouteRouteChildren: workspacePayrollRouteRouteChildren = {
  workspacePayrollIndexRoute: workspacePayrollIndexRoute,
  workspacePayrollEmployeesNewRoute: workspacePayrollEmployeesNewRoute,
  workspacePayrollRunIdIndexRoute: workspacePayrollRunIdIndexRoute,
  workspacePayrollEmployeesIndexRoute: workspacePayrollEmployeesIndexRoute,
  workspacePayrollEmployeesEmployeeIdEditRoute:
    workspacePayrollEmployeesEmployeeIdEditRoute,
  workspacePayrollEmployeesEmployeeIdIndexRoute:
    workspacePayrollEmployeesEmployeeIdIndexRoute,
}

const workspacePayrollRouteRouteWithChildren =
  workspacePayrollRouteRoute._addFileChildren(
    workspacePayrollRouteRouteChildren,
  )

interface workspaceReportsRouteRouteChildren {
  workspaceReportsReportKeyRoute: typeof workspaceReportsReportKeyRoute
  workspaceReportsNewRoute: typeof workspaceReportsNewRoute
  workspaceReportsIndexRoute: typeof workspaceReportsIndexRoute
}

const workspaceReportsRouteRouteChildren: workspaceReportsRouteRouteChildren = {
  workspaceReportsReportKeyRoute: workspaceReportsReportKeyRoute,
  workspaceReportsNewRoute: workspaceReportsNewRoute,
  workspaceReportsIndexRoute: workspaceReportsIndexRoute,
}

const workspaceReportsRouteRouteWithChildren =
  workspaceReportsRouteRoute._addFileChildren(
    workspaceReportsRouteRouteChildren,
  )

interface workspaceApprovalsRouteChildren {
  workspaceApprovalsApprovalIdRoute: typeof workspaceApprovalsApprovalIdRoute
  workspaceApprovalsIndexRoute: typeof workspaceApprovalsIndexRoute
}

const workspaceApprovalsRouteChildren: workspaceApprovalsRouteChildren = {
  workspaceApprovalsApprovalIdRoute: workspaceApprovalsApprovalIdRoute,
  workspaceApprovalsIndexRoute: workspaceApprovalsIndexRoute,
}

const workspaceApprovalsRouteWithChildren =
  workspaceApprovalsRoute._addFileChildren(workspaceApprovalsRouteChildren)

interface workspaceCashMovementsRouteRouteChildren {
  workspaceCashMovementsNewRoute: typeof workspaceCashMovementsNewRoute
}

const workspaceCashMovementsRouteRouteChildren: workspaceCashMovementsRouteRouteChildren =
  {
    workspaceCashMovementsNewRoute: workspaceCashMovementsNewRoute,
  }

const workspaceCashMovementsRouteRouteWithChildren =
  workspaceCashMovementsRouteRoute._addFileChildren(
    workspaceCashMovementsRouteRouteChildren,
  )

interface workspaceCashPettyCashRouteRouteChildren {
  workspaceCashPettyCashVoucherIdRoute: typeof workspaceCashPettyCashVoucherIdRoute
  workspaceCashPettyCashCountRoute: typeof workspaceCashPettyCashCountRoute
  workspaceCashPettyCashCountsRoute: typeof workspaceCashPettyCashCountsRoute
  workspaceCashPettyCashNewRoute: typeof workspaceCashPettyCashNewRoute
  workspaceCashPettyCashReplenishRoute: typeof workspaceCashPettyCashReplenishRoute
  workspaceCashPettyCashIndexRoute: typeof workspaceCashPettyCashIndexRoute
}

const workspaceCashPettyCashRouteRouteChildren: workspaceCashPettyCashRouteRouteChildren =
  {
    workspaceCashPettyCashVoucherIdRoute: workspaceCashPettyCashVoucherIdRoute,
    workspaceCashPettyCashCountRoute: workspaceCashPettyCashCountRoute,
    workspaceCashPettyCashCountsRoute: workspaceCashPettyCashCountsRoute,
    workspaceCashPettyCashNewRoute: workspaceCashPettyCashNewRoute,
    workspaceCashPettyCashReplenishRoute: workspaceCashPettyCashReplenishRoute,
    workspaceCashPettyCashIndexRoute: workspaceCashPettyCashIndexRoute,
  }

const workspaceCashPettyCashRouteRouteWithChildren =
  workspaceCashPettyCashRouteRoute._addFileChildren(
    workspaceCashPettyCashRouteRouteChildren,
  )

interface workspaceCashReconcileRouteRouteChildren {
  workspaceCashReconcileIndexRoute: typeof workspaceCashReconcileIndexRoute
}

const workspaceCashReconcileRouteRouteChildren: workspaceCashReconcileRouteRouteChildren =
  {
    workspaceCashReconcileIndexRoute: workspaceCashReconcileIndexRoute,
  }

const workspaceCashReconcileRouteRouteWithChildren =
  workspaceCashReconcileRouteRoute._addFileChildren(
    workspaceCashReconcileRouteRouteChildren,
  )

interface workspaceCashTransfersRouteRouteChildren {
  workspaceCashTransfersMovementIdRoute: typeof workspaceCashTransfersMovementIdRoute
  workspaceCashTransfersNewRoute: typeof workspaceCashTransfersNewRoute
  workspaceCashTransfersIndexRoute: typeof workspaceCashTransfersIndexRoute
}

const workspaceCashTransfersRouteRouteChildren: workspaceCashTransfersRouteRouteChildren =
  {
    workspaceCashTransfersMovementIdRoute:
      workspaceCashTransfersMovementIdRoute,
    workspaceCashTransfersNewRoute: workspaceCashTransfersNewRoute,
    workspaceCashTransfersIndexRoute: workspaceCashTransfersIndexRoute,
  }

const workspaceCashTransfersRouteRouteWithChildren =
  workspaceCashTransfersRouteRoute._addFileChildren(
    workspaceCashTransfersRouteRouteChildren,
  )

interface workspaceComplianceBooksRouteRouteChildren {
  workspaceComplianceBooksIndexRoute: typeof workspaceComplianceBooksIndexRoute
}

const workspaceComplianceBooksRouteRouteChildren: workspaceComplianceBooksRouteRouteChildren =
  {
    workspaceComplianceBooksIndexRoute: workspaceComplianceBooksIndexRoute,
  }

const workspaceComplianceBooksRouteRouteWithChildren =
  workspaceComplianceBooksRouteRoute._addFileChildren(
    workspaceComplianceBooksRouteRouteChildren,
  )

interface workspaceInventoryStockTransfersRouteRouteChildren {
  workspaceInventoryStockTransfersNewRoute: typeof workspaceInventoryStockTransfersNewRoute
  workspaceInventoryStockTransfersIndexRoute: typeof workspaceInventoryStockTransfersIndexRoute
}

const workspaceInventoryStockTransfersRouteRouteChildren: workspaceInventoryStockTransfersRouteRouteChildren =
  {
    workspaceInventoryStockTransfersNewRoute:
      workspaceInventoryStockTransfersNewRoute,
    workspaceInventoryStockTransfersIndexRoute:
      workspaceInventoryStockTransfersIndexRoute,
  }

const workspaceInventoryStockTransfersRouteRouteWithChildren =
  workspaceInventoryStockTransfersRouteRoute._addFileChildren(
    workspaceInventoryStockTransfersRouteRouteChildren,
  )

interface workspaceRouteRouteChildren {
  workspaceDocumentsRouteRoute: typeof workspaceDocumentsRouteRouteWithChildren
  workspacePayrollRouteRoute: typeof workspacePayrollRouteRouteWithChildren
  workspaceReportsRouteRoute: typeof workspaceReportsRouteRouteWithChildren
  workspaceApprovalsRoute: typeof workspaceApprovalsRouteWithChildren
  workspaceIndexRoute: typeof workspaceIndexRoute
  workspaceCashMovementsRouteRoute: typeof workspaceCashMovementsRouteRouteWithChildren
  workspaceCashPettyCashRouteRoute: typeof workspaceCashPettyCashRouteRouteWithChildren
  workspaceCashReconcileRouteRoute: typeof workspaceCashReconcileRouteRouteWithChildren
  workspaceCashTransfersRouteRoute: typeof workspaceCashTransfersRouteRouteWithChildren
  workspaceComplianceBooksRouteRoute: typeof workspaceComplianceBooksRouteRouteWithChildren
  workspaceInventoryStockTransfersRouteRoute: typeof workspaceInventoryStockTransfersRouteRouteWithChildren
  workspaceAskChatIdRoute: typeof workspaceAskChatIdRoute
  workspaceAskIndexRoute: typeof workspaceAskIndexRoute
  workspaceProfileIndexRoute: typeof workspaceProfileIndexRoute
  workspaceSettingsIndexRoute: typeof workspaceSettingsIndexRoute
  workspaceCashBankAccountsNewRoute: typeof workspaceCashBankAccountsNewRoute
  workspaceInventoryStockAdjustmentsNewRoute: typeof workspaceInventoryStockAdjustmentsNewRoute
  workspaceInventoryStockOpeningRoute: typeof workspaceInventoryStockOpeningRoute
  workspaceInventoryWarehousesNewRoute: typeof workspaceInventoryWarehousesNewRoute
  workspaceMerchandisingOrdersNewRoute: typeof workspaceMerchandisingOrdersNewRoute
  workspaceMerchandisingStylesNewRoute: typeof workspaceMerchandisingStylesNewRoute
  workspaceProcurementBillsNewRoute: typeof workspaceProcurementBillsNewRoute
  workspaceProcurementGoodsReceiptsNewRoute: typeof workspaceProcurementGoodsReceiptsNewRoute
  workspaceProcurementPurchaseOrdersNewRoute: typeof workspaceProcurementPurchaseOrdersNewRoute
  workspaceProcurementVendorsNewRoute: typeof workspaceProcurementVendorsNewRoute
  workspaceProductionFloorStageRoute: typeof workspaceProductionFloorStageRoute
  workspaceProductionFloorInwardRoute: typeof workspaceProductionFloorInwardRoute
  workspaceSalesCustomersNewRoute: typeof workspaceSalesCustomersNewRoute
  workspaceSalesInvoicesNewRoute: typeof workspaceSalesInvoicesNewRoute
  workspaceSalesItemsNewRoute: typeof workspaceSalesItemsNewRoute
  workspaceSalesProformasNewRoute: typeof workspaceSalesProformasNewRoute
  workspaceSalesReceiptsReceiptIdRoute: typeof workspaceSalesReceiptsReceiptIdRoute
  workspaceCashBankAccountsIndexRoute: typeof workspaceCashBankAccountsIndexRoute
  workspaceComplianceGstReturnsIndexRoute: typeof workspaceComplianceGstReturnsIndexRoute
  workspaceComplianceItc04IndexRoute: typeof workspaceComplianceItc04IndexRoute
  workspaceComplianceTdsIndexRoute: typeof workspaceComplianceTdsIndexRoute
  workspaceInventoryStockAdjustmentsIndexRoute: typeof workspaceInventoryStockAdjustmentsIndexRoute
  workspaceInventoryStockIndexRoute: typeof workspaceInventoryStockIndexRoute
  workspaceInventoryWarehousesIndexRoute: typeof workspaceInventoryWarehousesIndexRoute
  workspaceMerchandisingOrdersIndexRoute: typeof workspaceMerchandisingOrdersIndexRoute
  workspaceMerchandisingRisksIndexRoute: typeof workspaceMerchandisingRisksIndexRoute
  workspaceMerchandisingStylesIndexRoute: typeof workspaceMerchandisingStylesIndexRoute
  workspacePosShiftsIndexRoute: typeof workspacePosShiftsIndexRoute
  workspaceProcurementBillsIndexRoute: typeof workspaceProcurementBillsIndexRoute
  workspaceProcurementGoodsReceiptsIndexRoute: typeof workspaceProcurementGoodsReceiptsIndexRoute
  workspaceProcurementPaymentsIndexRoute: typeof workspaceProcurementPaymentsIndexRoute
  workspaceProcurementPurchaseOrdersIndexRoute: typeof workspaceProcurementPurchaseOrdersIndexRoute
  workspaceProcurementVendorsIndexRoute: typeof workspaceProcurementVendorsIndexRoute
  workspaceProductionFloorIndexRoute: typeof workspaceProductionFloorIndexRoute
  workspaceRecordsAuditLogIndexRoute: typeof workspaceRecordsAuditLogIndexRoute
  workspaceSalesCollectionsIndexRoute: typeof workspaceSalesCollectionsIndexRoute
  workspaceSalesCustomersIndexRoute: typeof workspaceSalesCustomersIndexRoute
  workspaceSalesInvoicesIndexRoute: typeof workspaceSalesInvoicesIndexRoute
  workspaceSalesItemsIndexRoute: typeof workspaceSalesItemsIndexRoute
  workspaceSalesProformasIndexRoute: typeof workspaceSalesProformasIndexRoute
  workspaceSalesReceiptsIndexRoute: typeof workspaceSalesReceiptsIndexRoute
  workspaceSettingsAboutIndexRoute: typeof workspaceSettingsAboutIndexRoute
  workspaceSettingsApprovalsIndexRoute: typeof workspaceSettingsApprovalsIndexRoute
  workspaceSettingsAssistantIndexRoute: typeof workspaceSettingsAssistantIndexRoute
  workspaceSettingsBillingIndexRoute: typeof workspaceSettingsBillingIndexRoute
  workspaceSettingsCompanyIndexRoute: typeof workspaceSettingsCompanyIndexRoute
  workspaceSettingsGstinIndexRoute: typeof workspaceSettingsGstinIndexRoute
  workspaceSettingsIntegrationsIndexRoute: typeof workspaceSettingsIntegrationsIndexRoute
  workspaceSettingsNotificationsIndexRoute: typeof workspaceSettingsNotificationsIndexRoute
  workspaceSettingsNumberingIndexRoute: typeof workspaceSettingsNumberingIndexRoute
  workspaceSettingsProfileIndexRoute: typeof workspaceSettingsProfileIndexRoute
  workspaceSettingsRecurringIndexRoute: typeof workspaceSettingsRecurringIndexRoute
  workspaceSettingsRolesIndexRoute: typeof workspaceSettingsRolesIndexRoute
  workspaceSettingsSubscriptionIndexRoute: typeof workspaceSettingsSubscriptionIndexRoute
  workspaceSettingsTeamIndexRoute: typeof workspaceSettingsTeamIndexRoute
  workspaceSettingsTemplatesIndexRoute: typeof workspaceSettingsTemplatesIndexRoute
  workspaceStoreAdminIndexRoute: typeof workspaceStoreAdminIndexRoute
  workspaceCashBankAccountsBankAccountIdEditRoute: typeof workspaceCashBankAccountsBankAccountIdEditRoute
  workspaceInventoryWarehousesWarehouseIdEditRoute: typeof workspaceInventoryWarehousesWarehouseIdEditRoute
  workspaceMerchandisingOrdersOrderIdEditRoute: typeof workspaceMerchandisingOrdersOrderIdEditRoute
  workspaceMerchandisingStylesStyleIdCostingRoute: typeof workspaceMerchandisingStylesStyleIdCostingRoute
  workspaceMerchandisingStylesStyleIdDispatchRoute: typeof workspaceMerchandisingStylesStyleIdDispatchRoute
  workspaceMerchandisingStylesStyleIdMaterialsRoute: typeof workspaceMerchandisingStylesStyleIdMaterialsRoute
  workspaceMerchandisingStylesStyleIdOverviewRoute: typeof workspaceMerchandisingStylesStyleIdOverviewRoute
  workspaceMerchandisingStylesStyleIdTimelineRoute: typeof workspaceMerchandisingStylesStyleIdTimelineRoute
  workspaceMerchandisingStylesStyleIdVisualRoute: typeof workspaceMerchandisingStylesStyleIdVisualRoute
  workspaceProcurementBillsBillIdEditRoute: typeof workspaceProcurementBillsBillIdEditRoute
  workspaceProcurementGoodsReceiptsGrnIdEditRoute: typeof workspaceProcurementGoodsReceiptsGrnIdEditRoute
  workspaceProcurementPurchaseOrdersPoIdEditRoute: typeof workspaceProcurementPurchaseOrdersPoIdEditRoute
  workspaceProcurementVendorsVendorIdEditRoute: typeof workspaceProcurementVendorsVendorIdEditRoute
  workspaceProductionStylesStyleIdProductionRoute: typeof workspaceProductionStylesStyleIdProductionRoute
  workspaceQualityStylesStyleIdQcRoute: typeof workspaceQualityStylesStyleIdQcRoute
  workspaceSalesCustomersCustomerIdEditRoute: typeof workspaceSalesCustomersCustomerIdEditRoute
  workspaceSalesCustomersCustomerIdLedgerRoute: typeof workspaceSalesCustomersCustomerIdLedgerRoute
  workspaceSalesInvoicesInvoiceIdEditRoute: typeof workspaceSalesInvoicesInvoiceIdEditRoute
  workspaceSalesItemsItemIdEditRoute: typeof workspaceSalesItemsItemIdEditRoute
  workspaceSalesProformasProformaIdEditRoute: typeof workspaceSalesProformasProformaIdEditRoute
  workspaceSamplingStylesStyleIdSamplesRoute: typeof workspaceSamplingStylesStyleIdSamplesRoute
  workspaceStoreAdminCollectionsNewRoute: typeof workspaceStoreAdminCollectionsNewRoute
  workspaceStoreAdminProductsNewRoute: typeof workspaceStoreAdminProductsNewRoute
  workspaceStoreAdminQuotesNewRoute: typeof workspaceStoreAdminQuotesNewRoute
  workspaceCashBankAccountsBankAccountIdIndexRoute: typeof workspaceCashBankAccountsBankAccountIdIndexRoute
  workspaceInventoryWarehousesWarehouseIdIndexRoute: typeof workspaceInventoryWarehousesWarehouseIdIndexRoute
  workspaceMerchandisingOrdersOrderIdIndexRoute: typeof workspaceMerchandisingOrdersOrderIdIndexRoute
  workspaceMerchandisingStylesStyleIdIndexRoute: typeof workspaceMerchandisingStylesStyleIdIndexRoute
  workspaceProcurementBillsBillIdIndexRoute: typeof workspaceProcurementBillsBillIdIndexRoute
  workspaceProcurementGoodsReceiptsGrnIdIndexRoute: typeof workspaceProcurementGoodsReceiptsGrnIdIndexRoute
  workspaceProcurementPurchaseOrdersPoIdIndexRoute: typeof workspaceProcurementPurchaseOrdersPoIdIndexRoute
  workspaceProcurementVendorsVendorIdIndexRoute: typeof workspaceProcurementVendorsVendorIdIndexRoute
  workspaceSalesCustomersCustomerIdIndexRoute: typeof workspaceSalesCustomersCustomerIdIndexRoute
  workspaceSalesInvoicesInvoiceIdIndexRoute: typeof workspaceSalesInvoicesInvoiceIdIndexRoute
  workspaceSalesItemsItemIdIndexRoute: typeof workspaceSalesItemsItemIdIndexRoute
  workspaceSalesProformasProformaIdIndexRoute: typeof workspaceSalesProformasProformaIdIndexRoute
  workspaceStoreAdminBuyersIndexRoute: typeof workspaceStoreAdminBuyersIndexRoute
  workspaceStoreAdminCollectionsIndexRoute: typeof workspaceStoreAdminCollectionsIndexRoute
  workspaceStoreAdminOrdersIndexRoute: typeof workspaceStoreAdminOrdersIndexRoute
  workspaceStoreAdminPacksIndexRoute: typeof workspaceStoreAdminPacksIndexRoute
  workspaceStoreAdminPagesIndexRoute: typeof workspaceStoreAdminPagesIndexRoute
  workspaceStoreAdminProductsIndexRoute: typeof workspaceStoreAdminProductsIndexRoute
  workspaceStoreAdminQuotesIndexRoute: typeof workspaceStoreAdminQuotesIndexRoute
  workspaceStoreAdminReportsIndexRoute: typeof workspaceStoreAdminReportsIndexRoute
  workspaceStoreAdminReturnsIndexRoute: typeof workspaceStoreAdminReturnsIndexRoute
  workspaceStoreAdminSamplingIndexRoute: typeof workspaceStoreAdminSamplingIndexRoute
  workspaceStoreAdminStorefrontIndexRoute: typeof workspaceStoreAdminStorefrontIndexRoute
  workspaceMerchandisingStylesStyleIdDesignPackRoute: typeof workspaceMerchandisingStylesStyleIdDesignPackRoute
  workspaceStoreAdminCollectionsCollectionIdEditRoute: typeof workspaceStoreAdminCollectionsCollectionIdEditRoute
  workspaceStoreAdminProductsListingIdEditRoute: typeof workspaceStoreAdminProductsListingIdEditRoute
  workspaceMerchandisingStylesStyleIdDesignIndexRoute: typeof workspaceMerchandisingStylesStyleIdDesignIndexRoute
  workspaceStoreAdminBuyersBuyerIdIndexRoute: typeof workspaceStoreAdminBuyersBuyerIdIndexRoute
  workspaceStoreAdminCollectionsCollectionIdIndexRoute: typeof workspaceStoreAdminCollectionsCollectionIdIndexRoute
  workspaceStoreAdminOrdersOrderIdIndexRoute: typeof workspaceStoreAdminOrdersOrderIdIndexRoute
  workspaceStoreAdminProductsListingIdIndexRoute: typeof workspaceStoreAdminProductsListingIdIndexRoute
  workspaceStoreAdminQuotesQuoteIdIndexRoute: typeof workspaceStoreAdminQuotesQuoteIdIndexRoute
  workspaceStoreAdminSamplingSampleIdIndexRoute: typeof workspaceStoreAdminSamplingSampleIdIndexRoute
  workspaceStoreAdminStorefrontAppearanceIdIndexRoute: typeof workspaceStoreAdminStorefrontAppearanceIdIndexRoute
  workspaceStoreAdminStorefrontAppearanceIdPreviewIndexRoute: typeof workspaceStoreAdminStorefrontAppearanceIdPreviewIndexRoute
  workspaceStoreAdminStorefrontTemplatesTemplateKeyIndexRoute: typeof workspaceStoreAdminStorefrontTemplatesTemplateKeyIndexRoute
}

const workspaceRouteRouteChildren: workspaceRouteRouteChildren = {
  workspaceDocumentsRouteRoute: workspaceDocumentsRouteRouteWithChildren,
  workspacePayrollRouteRoute: workspacePayrollRouteRouteWithChildren,
  workspaceReportsRouteRoute: workspaceReportsRouteRouteWithChildren,
  workspaceApprovalsRoute: workspaceApprovalsRouteWithChildren,
  workspaceIndexRoute: workspaceIndexRoute,
  workspaceCashMovementsRouteRoute:
    workspaceCashMovementsRouteRouteWithChildren,
  workspaceCashPettyCashRouteRoute:
    workspaceCashPettyCashRouteRouteWithChildren,
  workspaceCashReconcileRouteRoute:
    workspaceCashReconcileRouteRouteWithChildren,
  workspaceCashTransfersRouteRoute:
    workspaceCashTransfersRouteRouteWithChildren,
  workspaceComplianceBooksRouteRoute:
    workspaceComplianceBooksRouteRouteWithChildren,
  workspaceInventoryStockTransfersRouteRoute:
    workspaceInventoryStockTransfersRouteRouteWithChildren,
  workspaceAskChatIdRoute: workspaceAskChatIdRoute,
  workspaceAskIndexRoute: workspaceAskIndexRoute,
  workspaceProfileIndexRoute: workspaceProfileIndexRoute,
  workspaceSettingsIndexRoute: workspaceSettingsIndexRoute,
  workspaceCashBankAccountsNewRoute: workspaceCashBankAccountsNewRoute,
  workspaceInventoryStockAdjustmentsNewRoute:
    workspaceInventoryStockAdjustmentsNewRoute,
  workspaceInventoryStockOpeningRoute: workspaceInventoryStockOpeningRoute,
  workspaceInventoryWarehousesNewRoute: workspaceInventoryWarehousesNewRoute,
  workspaceMerchandisingOrdersNewRoute: workspaceMerchandisingOrdersNewRoute,
  workspaceMerchandisingStylesNewRoute: workspaceMerchandisingStylesNewRoute,
  workspaceProcurementBillsNewRoute: workspaceProcurementBillsNewRoute,
  workspaceProcurementGoodsReceiptsNewRoute:
    workspaceProcurementGoodsReceiptsNewRoute,
  workspaceProcurementPurchaseOrdersNewRoute:
    workspaceProcurementPurchaseOrdersNewRoute,
  workspaceProcurementVendorsNewRoute: workspaceProcurementVendorsNewRoute,
  workspaceProductionFloorStageRoute: workspaceProductionFloorStageRoute,
  workspaceProductionFloorInwardRoute: workspaceProductionFloorInwardRoute,
  workspaceSalesCustomersNewRoute: workspaceSalesCustomersNewRoute,
  workspaceSalesInvoicesNewRoute: workspaceSalesInvoicesNewRoute,
  workspaceSalesItemsNewRoute: workspaceSalesItemsNewRoute,
  workspaceSalesProformasNewRoute: workspaceSalesProformasNewRoute,
  workspaceSalesReceiptsReceiptIdRoute: workspaceSalesReceiptsReceiptIdRoute,
  workspaceCashBankAccountsIndexRoute: workspaceCashBankAccountsIndexRoute,
  workspaceComplianceGstReturnsIndexRoute:
    workspaceComplianceGstReturnsIndexRoute,
  workspaceComplianceItc04IndexRoute: workspaceComplianceItc04IndexRoute,
  workspaceComplianceTdsIndexRoute: workspaceComplianceTdsIndexRoute,
  workspaceInventoryStockAdjustmentsIndexRoute:
    workspaceInventoryStockAdjustmentsIndexRoute,
  workspaceInventoryStockIndexRoute: workspaceInventoryStockIndexRoute,
  workspaceInventoryWarehousesIndexRoute:
    workspaceInventoryWarehousesIndexRoute,
  workspaceMerchandisingOrdersIndexRoute:
    workspaceMerchandisingOrdersIndexRoute,
  workspaceMerchandisingRisksIndexRoute: workspaceMerchandisingRisksIndexRoute,
  workspaceMerchandisingStylesIndexRoute:
    workspaceMerchandisingStylesIndexRoute,
  workspacePosShiftsIndexRoute: workspacePosShiftsIndexRoute,
  workspaceProcurementBillsIndexRoute: workspaceProcurementBillsIndexRoute,
  workspaceProcurementGoodsReceiptsIndexRoute:
    workspaceProcurementGoodsReceiptsIndexRoute,
  workspaceProcurementPaymentsIndexRoute:
    workspaceProcurementPaymentsIndexRoute,
  workspaceProcurementPurchaseOrdersIndexRoute:
    workspaceProcurementPurchaseOrdersIndexRoute,
  workspaceProcurementVendorsIndexRoute: workspaceProcurementVendorsIndexRoute,
  workspaceProductionFloorIndexRoute: workspaceProductionFloorIndexRoute,
  workspaceRecordsAuditLogIndexRoute: workspaceRecordsAuditLogIndexRoute,
  workspaceSalesCollectionsIndexRoute: workspaceSalesCollectionsIndexRoute,
  workspaceSalesCustomersIndexRoute: workspaceSalesCustomersIndexRoute,
  workspaceSalesInvoicesIndexRoute: workspaceSalesInvoicesIndexRoute,
  workspaceSalesItemsIndexRoute: workspaceSalesItemsIndexRoute,
  workspaceSalesProformasIndexRoute: workspaceSalesProformasIndexRoute,
  workspaceSalesReceiptsIndexRoute: workspaceSalesReceiptsIndexRoute,
  workspaceSettingsAboutIndexRoute: workspaceSettingsAboutIndexRoute,
  workspaceSettingsApprovalsIndexRoute: workspaceSettingsApprovalsIndexRoute,
  workspaceSettingsAssistantIndexRoute: workspaceSettingsAssistantIndexRoute,
  workspaceSettingsBillingIndexRoute: workspaceSettingsBillingIndexRoute,
  workspaceSettingsCompanyIndexRoute: workspaceSettingsCompanyIndexRoute,
  workspaceSettingsGstinIndexRoute: workspaceSettingsGstinIndexRoute,
  workspaceSettingsIntegrationsIndexRoute:
    workspaceSettingsIntegrationsIndexRoute,
  workspaceSettingsNotificationsIndexRoute:
    workspaceSettingsNotificationsIndexRoute,
  workspaceSettingsNumberingIndexRoute: workspaceSettingsNumberingIndexRoute,
  workspaceSettingsProfileIndexRoute: workspaceSettingsProfileIndexRoute,
  workspaceSettingsRecurringIndexRoute: workspaceSettingsRecurringIndexRoute,
  workspaceSettingsRolesIndexRoute: workspaceSettingsRolesIndexRoute,
  workspaceSettingsSubscriptionIndexRoute:
    workspaceSettingsSubscriptionIndexRoute,
  workspaceSettingsTeamIndexRoute: workspaceSettingsTeamIndexRoute,
  workspaceSettingsTemplatesIndexRoute: workspaceSettingsTemplatesIndexRoute,
  workspaceStoreAdminIndexRoute: workspaceStoreAdminIndexRoute,
  workspaceCashBankAccountsBankAccountIdEditRoute:
    workspaceCashBankAccountsBankAccountIdEditRoute,
  workspaceInventoryWarehousesWarehouseIdEditRoute:
    workspaceInventoryWarehousesWarehouseIdEditRoute,
  workspaceMerchandisingOrdersOrderIdEditRoute:
    workspaceMerchandisingOrdersOrderIdEditRoute,
  workspaceMerchandisingStylesStyleIdCostingRoute:
    workspaceMerchandisingStylesStyleIdCostingRoute,
  workspaceMerchandisingStylesStyleIdDispatchRoute:
    workspaceMerchandisingStylesStyleIdDispatchRoute,
  workspaceMerchandisingStylesStyleIdMaterialsRoute:
    workspaceMerchandisingStylesStyleIdMaterialsRoute,
  workspaceMerchandisingStylesStyleIdOverviewRoute:
    workspaceMerchandisingStylesStyleIdOverviewRoute,
  workspaceMerchandisingStylesStyleIdTimelineRoute:
    workspaceMerchandisingStylesStyleIdTimelineRoute,
  workspaceMerchandisingStylesStyleIdVisualRoute:
    workspaceMerchandisingStylesStyleIdVisualRoute,
  workspaceProcurementBillsBillIdEditRoute:
    workspaceProcurementBillsBillIdEditRoute,
  workspaceProcurementGoodsReceiptsGrnIdEditRoute:
    workspaceProcurementGoodsReceiptsGrnIdEditRoute,
  workspaceProcurementPurchaseOrdersPoIdEditRoute:
    workspaceProcurementPurchaseOrdersPoIdEditRoute,
  workspaceProcurementVendorsVendorIdEditRoute:
    workspaceProcurementVendorsVendorIdEditRoute,
  workspaceProductionStylesStyleIdProductionRoute:
    workspaceProductionStylesStyleIdProductionRoute,
  workspaceQualityStylesStyleIdQcRoute: workspaceQualityStylesStyleIdQcRoute,
  workspaceSalesCustomersCustomerIdEditRoute:
    workspaceSalesCustomersCustomerIdEditRoute,
  workspaceSalesCustomersCustomerIdLedgerRoute:
    workspaceSalesCustomersCustomerIdLedgerRoute,
  workspaceSalesInvoicesInvoiceIdEditRoute:
    workspaceSalesInvoicesInvoiceIdEditRoute,
  workspaceSalesItemsItemIdEditRoute: workspaceSalesItemsItemIdEditRoute,
  workspaceSalesProformasProformaIdEditRoute:
    workspaceSalesProformasProformaIdEditRoute,
  workspaceSamplingStylesStyleIdSamplesRoute:
    workspaceSamplingStylesStyleIdSamplesRoute,
  workspaceStoreAdminCollectionsNewRoute:
    workspaceStoreAdminCollectionsNewRoute,
  workspaceStoreAdminProductsNewRoute: workspaceStoreAdminProductsNewRoute,
  workspaceStoreAdminQuotesNewRoute: workspaceStoreAdminQuotesNewRoute,
  workspaceCashBankAccountsBankAccountIdIndexRoute:
    workspaceCashBankAccountsBankAccountIdIndexRoute,
  workspaceInventoryWarehousesWarehouseIdIndexRoute:
    workspaceInventoryWarehousesWarehouseIdIndexRoute,
  workspaceMerchandisingOrdersOrderIdIndexRoute:
    workspaceMerchandisingOrdersOrderIdIndexRoute,
  workspaceMerchandisingStylesStyleIdIndexRoute:
    workspaceMerchandisingStylesStyleIdIndexRoute,
  workspaceProcurementBillsBillIdIndexRoute:
    workspaceProcurementBillsBillIdIndexRoute,
  workspaceProcurementGoodsReceiptsGrnIdIndexRoute:
    workspaceProcurementGoodsReceiptsGrnIdIndexRoute,
  workspaceProcurementPurchaseOrdersPoIdIndexRoute:
    workspaceProcurementPurchaseOrdersPoIdIndexRoute,
  workspaceProcurementVendorsVendorIdIndexRoute:
    workspaceProcurementVendorsVendorIdIndexRoute,
  workspaceSalesCustomersCustomerIdIndexRoute:
    workspaceSalesCustomersCustomerIdIndexRoute,
  workspaceSalesInvoicesInvoiceIdIndexRoute:
    workspaceSalesInvoicesInvoiceIdIndexRoute,
  workspaceSalesItemsItemIdIndexRoute: workspaceSalesItemsItemIdIndexRoute,
  workspaceSalesProformasProformaIdIndexRoute:
    workspaceSalesProformasProformaIdIndexRoute,
  workspaceStoreAdminBuyersIndexRoute: workspaceStoreAdminBuyersIndexRoute,
  workspaceStoreAdminCollectionsIndexRoute:
    workspaceStoreAdminCollectionsIndexRoute,
  workspaceStoreAdminOrdersIndexRoute: workspaceStoreAdminOrdersIndexRoute,
  workspaceStoreAdminPacksIndexRoute: workspaceStoreAdminPacksIndexRoute,
  workspaceStoreAdminPagesIndexRoute: workspaceStoreAdminPagesIndexRoute,
  workspaceStoreAdminProductsIndexRoute: workspaceStoreAdminProductsIndexRoute,
  workspaceStoreAdminQuotesIndexRoute: workspaceStoreAdminQuotesIndexRoute,
  workspaceStoreAdminReportsIndexRoute: workspaceStoreAdminReportsIndexRoute,
  workspaceStoreAdminReturnsIndexRoute: workspaceStoreAdminReturnsIndexRoute,
  workspaceStoreAdminSamplingIndexRoute: workspaceStoreAdminSamplingIndexRoute,
  workspaceStoreAdminStorefrontIndexRoute:
    workspaceStoreAdminStorefrontIndexRoute,
  workspaceMerchandisingStylesStyleIdDesignPackRoute:
    workspaceMerchandisingStylesStyleIdDesignPackRoute,
  workspaceStoreAdminCollectionsCollectionIdEditRoute:
    workspaceStoreAdminCollectionsCollectionIdEditRoute,
  workspaceStoreAdminProductsListingIdEditRoute:
    workspaceStoreAdminProductsListingIdEditRoute,
  workspaceMerchandisingStylesStyleIdDesignIndexRoute:
    workspaceMerchandisingStylesStyleIdDesignIndexRoute,
  workspaceStoreAdminBuyersBuyerIdIndexRoute:
    workspaceStoreAdminBuyersBuyerIdIndexRoute,
  workspaceStoreAdminCollectionsCollectionIdIndexRoute:
    workspaceStoreAdminCollectionsCollectionIdIndexRoute,
  workspaceStoreAdminOrdersOrderIdIndexRoute:
    workspaceStoreAdminOrdersOrderIdIndexRoute,
  workspaceStoreAdminProductsListingIdIndexRoute:
    workspaceStoreAdminProductsListingIdIndexRoute,
  workspaceStoreAdminQuotesQuoteIdIndexRoute:
    workspaceStoreAdminQuotesQuoteIdIndexRoute,
  workspaceStoreAdminSamplingSampleIdIndexRoute:
    workspaceStoreAdminSamplingSampleIdIndexRoute,
  workspaceStoreAdminStorefrontAppearanceIdIndexRoute:
    workspaceStoreAdminStorefrontAppearanceIdIndexRoute,
  workspaceStoreAdminStorefrontAppearanceIdPreviewIndexRoute:
    workspaceStoreAdminStorefrontAppearanceIdPreviewIndexRoute,
  workspaceStoreAdminStorefrontTemplatesTemplateKeyIndexRoute:
    workspaceStoreAdminStorefrontTemplatesTemplateKeyIndexRoute,
}

const workspaceRouteRouteWithChildren = workspaceRouteRoute._addFileChildren(
  workspaceRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  workspaceRouteRoute: workspaceRouteRouteWithChildren,
  LaunchRoute: LaunchRoute,
  PosRoute: PosRoute,
  SubscriptionEndedRoute: SubscriptionEndedRoute,
  StationIndexRoute: StationIndexRoute,
  authJoinTokenRoute: authJoinTokenRoute,
  authOnboardingAccountRoute: authOnboardingAccountRoute,
  authOnboardingDoneRoute: authOnboardingDoneRoute,
  authOnboardingTallyRoute: authOnboardingTallyRoute,
  authOnboardingWorkspaceRoute: authOnboardingWorkspaceRoute,
  authSignInOtpRoute: authSignInOtpRoute,
  authSignInIndexRoute: authSignInIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
